import * as $ from 'jquery';
import {renderWidgetTemplate} from "./templates/widgetTemplates";
import {mockups} from "./mockUp/mockup";
import {
    checkSectorsAvailable,
    editSite,
    filterPlacesPrice,
    filterSectorsPrice,
    findMaxPrice,
    findMinPrice, getCookie,
    getRightTerm,
    hidePreloader,
    initCovidHandler,
    initSliders,
    isDataCorrect,
    isDesktop,
    isEmpty,
    number_format,
    renderRoute, setCookie,
    scrollToTop,
    showPreloader,
    validateDualInput, isNan,
} from "./helpers";
import {renderArena} from "./templates/chooseSectorTemplates";
import {renderPartners} from "./templates/partners";
import {renderPlaces, renderTicketsPopup} from "./templates/choosePlaceTemplates";
import {hidePopupChoosePlace, setPopupPosition} from "./popups/popups";
import {calculateFullPrice, renderParking, renderServices, renderTicketsInfo} from "./templates/orderInfoTemplates";
import {initFillControlInput, initMaskedInput, initPlaceholders} from "./helpers/inputs";
import {validateField, validateForm} from "./helpers/validator";
import {metallurgArena, samaraArenaConfig} from "./arenasConfig";
import {renderSubmitOrderTickets} from "./templates/submitOrderTemplates";
import {translator} from "./helpers/translator";

export function initWidget() {
    const AJAX_MODE = 'prod';

    let AJAX_URL = '';
    let AJAX_AUTH_URL = '';
    let AJAX_USER_PROFILE_URL = '';

    switch (AJAX_MODE) {
        case 'dev':
            AJAX_URL = '';
            AJAX_AUTH_URL = '';
            AJAX_USER_PROFILE_URL = '';
            break;

        case 'test':
            AJAX_URL = 'https://kstickets.internetlab.ru';
            AJAX_AUTH_URL = 'https://ksid-api.internetlab.ru';
            AJAX_USER_PROFILE_URL = 'https://ksid-api.internetlab.ru/api';
            break;

        case 'prod':
            AJAX_URL = 'https://tickets.pfcks.ru';
            AJAX_AUTH_URL = 'https://api.pfcks.ru';
            AJAX_USER_PROFILE_URL = 'https://api.pfcks.ru/api';
            break;
    }

    //для второго теста (biletnaya-sistema-x2)
    if(AJAX_MODE === 'test' && window.location.href.includes('biletnaya-sistema-x2')){
        AJAX_URL = 'https://ks-tickets-new.internetlab.ru';
    }

    const WIDGET_DATA = {
        /* userId: 1,*/
        userInfo: {
            phone_or_email: '',
            lastName: '',
            firstName: '',
            seatInReserve: []
        },
        fanIdRequired: true,
        customSectorAccess: false,
        availableDiscountTickets: 0,
        lang: 'ru',
        isUserAuthorized: 0,
        matchId: 1,
        previousPage: '',
        currentPage: '',
        locationVariants: ['choose_sector', 'choose_place', 'order_info', 'submit_order', 'error_page', 'tickets_page'],
        matchInfo: {},
        partners: [],
        sectors: [],
        sectorSvgObjects: [],
        placesDOMElements: [],
        customVipSectors: [82191, 82419, 82904],
        parkingProducts: [],
        serviceProducts: [],
        covidFlag: 0,
        drawingOptions: {
            id: 'ticket_system_choose_sector_drawing',
            image: '',
            sectors: [],
            width: 870,
            height: 798,
            colorDisabled: '#0b193b',
            colorHover: '#2E416F',
            stroke: {color: '#27365B', opacity: 1, width: 1, dasharray: '0'},
            strokeWidth: 1,
            strokeColor: '#27365B',
            strokeOpacity: 1,
            dasharray: '0',
            isMetallArena: false
        },
        minPrice: '999999',
        maxPrice: '0',
        sliderFrom: 0,
        sliderTo: 0,
        defaultMinPrice: 0,
        defaultMaxPrice: 0,
        chosenSector: {},
        disabledSectors: ['Skybox S330-S357', 'Skybox S311-S320', 'Skybox S301-S310', 'Skybox S330 - S357'],
        disabledSectorsWithoutPopup: [ 124151 ],
        chosenTickets: [],
        isTicketsSwiperInited: 0,
        orderFullPrice: 0,
        order: [],
        sendOrderName : '',
        sendOrderFamily: '',
        isWidgetInited: 0,
        isPlacesPageInited: 0,
        isSubmitOrderPageInited: 0,
        isOrderInfoPageInited: 0,
        isPaymentStatusSuccess: 0,
        zoomValue: 100,
        currentPhoneOrEmailMask: 'email',
        localState: {},
        sendPaymentStatusCount: 0,
        emailFromSendPaymentStatus: '',
        chosenServices: [],
        chosenParkings: [],
        isAbonement: false,
        abonementData: {
            seat: "",
            sector: "",
            zoneId: "",
            categoryId: "",
            limit: 0,
            name: "",
            year: "",
            img: ""
        },
        currentChosenTicket:{},
        deadlineTimerInstance: 0,
        isPromocodesAvailable: false,
        currentFullPrice: 0,
        promocodeData:{
            code: '',
            discount_value: 0,
            discount_type: '',
            min_value: null,
            isPromocodeAccepted: false
        },
        authLink: ''
    }

    const $domElements = {
        body: $('body'),
        mainBlock: $('#ticket_system_main_block'),
        header: null,
        contentBlock: null,
        clickedTicket: null,
        chooseSectorBlock: null,
        choosePlaceBlock: null,
        orderInfoBlock: null,
        submitOrderBlock: null,
        placesWrapper: null,
        popupChooseSector: null,
        popupChooseSectorContent: null,
        popupFilter: null,
        popupChoosePlace: null,
        popupChoosePlaceContent: null,
        popupTickets: null,
        popupTicketsWrapper: null,
        preloader: null,
        returnBlock: null,
        headerMatchInfo: null,
        filterDesktop: null,
        orderInfoTicketsWrapper: null,
        submitOrderForm: null,
        sliderMin: null,
        sliderMax: null
    }

    if ($domElements.mainBlock.length === 0) {
        return;
    }

    //если есть подкаталог /en/ -> англ язык
    if(window.location.pathname.includes('/en/')){
        WIDGET_DATA.lang = 'en';

    }else{
        WIDGET_DATA.lang = 'ru';
    }

    setInitWidgetData();
    renderWidgetTemplate(AJAX_MODE, WIDGET_DATA.lang);
    setDomElements();
    getWidgetData();

    //изменение хеша
    $(window).on('hashchange', () => {
        checkLocationHash();
    });

    //вешаем обработчик до запроса за данными виджета
    //закрытие ошибочного экрана
    $domElements.body.on('click', '[data-ticket-system-error-button]', () => {
        $domElements.errorPage.css('display', 'none');
        //редирект на изначальную страницу виджета
        window.location.href = window.location.origin + window.location.pathname + `?matchId=${WIDGET_DATA.matchId}`;
    });

    //перезагрузка страницы в случае неуспешной оплаты (попробуйте ещё раз)
    $domElements.body.on('click', '[data-ticket-system-error-refresh-button]', () => {
        window.location.reload();
    });

    function checkLocationHash() {

        const currentHash = window.location.hash.slice(1);
        //получаем гет параметры (для отслеживания статуса оплаты)
        const getParameters = window.location.search;
        //для тестовой среды на internetlab
        const isGetParametersCorrect = getParameters.includes('orderId');
        let orderId = '';

        if (currentHash === 'error_page') {
            navigateTo('error_page');
            WIDGET_DATA.isPaymentStatusSuccess = 1;
        }

        //получаем из гет параметра id заказа
        if (isGetParametersCorrect) {
            orderId = window.location.search.split('&').find(getParameter => {
                return getParameter.includes('orderId');
            }).split('=')[1];
        }

        //если есть гет параметры и в них присутствует orderId
        // + мы ещё не получили билеты -> отправляем запрос на получение статуса оплаты
        if (getParameters && isGetParametersCorrect && orderId && !WIDGET_DATA.isPaymentStatusSuccess) {
            sendPaymentStatus(orderId);
            return;
        }

        //проверяем, есть ли у пользователя незавершенные шаги (выбрал сектор/места и ушел со страницы/перезагрузил)
        checkCookie();

        //если введён некорректный хеш -> редирект на выбор сектора
        if (!WIDGET_DATA.locationVariants.includes(currentHash)) {
            route('choose_sector');
        }

        if (currentHash === 'choose_sector') {
            navigateTo('choose_sector');

        } else if (currentHash === 'choose_place') {
            //если вручную переходим на Выбор места и не выбран сектор
            if (isEmpty(WIDGET_DATA.chosenSector)) {
                route('choose_sector');

            } else {
                navigateTo('choose_place');
            }

        } else if (currentHash === 'order_info') {

            //если вручную переходим на Инф. о заказе и не выбраны места
            if (WIDGET_DATA.chosenTickets.length === 0) {
                route('choose_place');

                //если вручную перешли с Подтверждения заказа -> переходим на информацию о заказе и удаляем бронь
            } else if (WIDGET_DATA.currentPage === 'submit_order') {
                navigateTo('order_info');
               /* deleteBooking();*/

                //если есть зарезервированные места -> переход на Подтверждение заказа
            } /*else if (WIDGET_DATA.userInfo.seatInReserve.length !== 0) {
                navigateTo('order_info');
                route('submit_order');

            }*/ else {
                navigateTo('order_info');
            }

        }else if (currentHash === 'submit_order') {
            //если вручную переходим на Подтверждени заказа и нет выбранных мест -> переходим на выбор сектора
            if (WIDGET_DATA.chosenTickets.length === 0 || isEmpty(WIDGET_DATA.chosenSector)) {
                route('choose_sector');

                //если есть зарезервированные места и
                // ещё не проинициализирована страница Оформления заказа -> переходим без бронирования на Подтверждение заказа
            } else if (WIDGET_DATA.userInfo.seatInReserve.length !== 0 && WIDGET_DATA.isSubmitOrderPageInited === 0) {
                WIDGET_DATA.previousPage = 'order_info';
                WIDGET_DATA.currentPage = 'submit_order';
                navigateTo('submit_order');

                //если нет мест ни в куке, ни в зарезервированных -> бронируем места и переходим
            } else {
                navigateTo('submit_order');
            }
            //страница с билетами
        } else if (currentHash === 'tickets_page') {
            navigateTo('tickets_page');

            //страница с ошибкой
        } else if (currentHash === 'error_page') {
            navigateTo('error_page');

        }

        scrollToTop();
    }

    //смена хеша
    function route(page) {
        window.location.hash = page;
    }

    //получение данных виджета
    function getWidgetData() {
        let data = {
            matchId: WIDGET_DATA.matchId,
            lang: WIDGET_DATA.lang
        };

        $.ajax({
            url: `${AJAX_URL}/ajax/getWidgetData/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn(data.payload);

                } else {
                    //если мы на странице оплаты, запрос прошел, но data невалидна - не показываем ошибочный экран
                    // (в случае, если для пользователя идёт ошибка)
                    const getParameters = window.location.search;
                    const isGetParametersCorrect = getParameters.includes('orderId');

                    if (!isGetParametersCorrect) {
                        errorHandler(data, 'widget');

                    } else {
                        successFn(data.payload);
                    }
                }
                initWidgetHandlers();
            },
            error: function () {
                if (AJAX_MODE === 'dev') {
                    const data = mockups.widgetDataMockUp;

                    if (isDataCorrect(data)) {
                        successFn(data.payload);

                    } else {
                        errorHandler(data, 'widget');
                    }

                } else {
                    if(data?.statusCode && data?.statusCode === '20111'){
                        errorHandler(data);
                    }else{
                        errorHandler(data, 'widget');
                    }
                }
                initWidgetHandlers();
            },
            timeout: 30000
        });

        function successFn(data) {
            //если есть данные по абонементу
            if (data?.subscription) {
                WIDGET_DATA.isAbonement = true;
                WIDGET_DATA.abonementData.limit = data.subscription.limit;

                WIDGET_DATA.abonementData.name = data.subscription.info.name;
                WIDGET_DATA.abonementData.year = data.subscription.info.year;
                WIDGET_DATA.abonementData.img = data.subscription.info.img;
                WIDGET_DATA.abonementData.seat = data.subscription?.seatInfo?.seat;
                WIDGET_DATA.abonementData.sector = data.subscription?.seatInfo?.sector;
                WIDGET_DATA.abonementData.zoneId = data.subscription?.seatInfo?.zoneId;
                WIDGET_DATA.abonementData.categoryId = data.subscription?.seatInfo?.categoryId;
            }

            if(data?.matchInfo.fanIdRequired === false){
                WIDGET_DATA.fanIdRequired = data?.matchInfo.fanIdRequired;
            }

            WIDGET_DATA.matchInfo = data?.matchInfo;
            WIDGET_DATA.partners = data?.partners;
            WIDGET_DATA.arenaId = data?.arenaId;

            if (WIDGET_DATA.arenaId === '23') {
                WIDGET_DATA.drawingOptions.isMetallArena = false;
                WIDGET_DATA.drawingOptions.image = samaraArenaConfig.arenaImage;

                //en подкаталог типо без лишней точки на пути к картинке
                if(WIDGET_DATA.lang === 'en'){
                    WIDGET_DATA.drawingOptions.image = samaraArenaConfig.arenaImage.slice(2);
                }

                WIDGET_DATA.drawingOptions.sectors = samaraArenaConfig.sectors;

            } else if (WIDGET_DATA.arenaId === '19') {
                WIDGET_DATA.drawingOptions.isMetallArena = true;
                WIDGET_DATA.drawingOptions.image = metallurgArena.arenaImage;
                WIDGET_DATA.drawingOptions.sectors = metallurgArena.sectors;

                //en подкаталог типо без лишней точки на пути к картинке
                if(WIDGET_DATA.lang === 'en'){
                    WIDGET_DATA.drawingOptions.image = metallurgArena.arenaImage.slice(2);
                }
            }

            //паркинг и доп. услуги
            if (data?.parking?.length) {
                WIDGET_DATA.parkingProducts = data.parking;

            } else {
                $domElements.orderInfoParkingSection.hide();
            }

            if (data?.services?.length) {
                WIDGET_DATA.serviceProducts = data.services;

            } else {
                $domElements.orderInfoServicesSection.hide();
            }

            if (data?.user) {
                setUserData(data?.user);
            }

            if (WIDGET_DATA?.matchInfo) {
                setHeaderData(WIDGET_DATA.matchInfo);
            }

            if (WIDGET_DATA?.partners) {
                renderPartners(WIDGET_DATA?.partners);
            }

            //количество билетов для покупки со скидкой
            if(data?.hasOwnProperty('discountTickets') && data?.discountTickets){
                WIDGET_DATA.availableDiscountTickets = data.discountTickets;
            }

            //максимальное количество билетов на тек покупку
            if(data?.hasOwnProperty('countBuyTickets') && data?.countBuyTickets){
                WIDGET_DATA.maxCountTickets = data?.countBuyTickets;
            }

            //доступность промокодов
            if(data?.hasOwnProperty('isPromocodesAvailable') && data?.isPromocodesAvailable){
                WIDGET_DATA.isPromocodesAvailable = true;
                $('.ticket-system__order-info__promocode-wrapper').removeClass('ticket-system__hide');
            }

            //если доступ по ссылке к b530 и 12 (металлург) - смотрим на забронированные места
            //если они есть и они не с сектора b530 и 12 (металлург) - удаляем бронь, аналогично для обратной ситуации
            if(WIDGET_DATA.customSectorAccess && !WIDGET_DATA.isAbonement){
                if(WIDGET_DATA.userInfo.seatInReserve.length){
                    const isReserveSeatsFromB530 = +WIDGET_DATA.userInfo.seatInReserve[0].sector === 122188 || +WIDGET_DATA.userInfo.seatInReserve[0].sector === 19846;

                    if(!isReserveSeatsFromB530){
                        deleteBooking(WIDGET_DATA.userInfo.seatInReserve, '', false, false);
                        WIDGET_DATA.userInfo.seatInReserve.length = 0;
                    }
                }

            }else{
                if(WIDGET_DATA.userInfo.seatInReserve.length && !WIDGET_DATA.isAbonement){
                    const isReserveSeatsFromB530 = +WIDGET_DATA.userInfo.seatInReserve[0].sector === 122188 || +WIDGET_DATA.userInfo.seatInReserve[0].sector === 19846;

                    if(isReserveSeatsFromB530){
                        deleteBooking(WIDGET_DATA.userInfo.seatInReserve, '', false, false);
                        WIDGET_DATA.userInfo.seatInReserve.length = 0;
                    }
                }
            }

            initMaskedInput();
            initFillControlInput();
            initPlaceholders();
            WIDGET_DATA.isWidgetInited = 1;
            checkLocationHash();
            //вспомогательная функция для манипуляции с сайтом
            editSite(WIDGET_DATA);
        }
    }

    //получение данных секторов
    function getSectorsData() {
        let data = {
            /*userId: WIDGET_DATA.userId,*/
            matchId: WIDGET_DATA.matchId,
        };

        $.ajax({
            url: `${AJAX_URL}/ajax/getSectors/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn(data.payload);

                } else {
                    errorHandler(data, 'get-sectors');
                }
            },
            error: function () {
                if (AJAX_MODE === 'dev') {
                    const data = mockups.chooseSectorMockUp

                    if (isDataCorrect(data) && data.payload.statusCode !== '20124') {
                        successFn(data.payload);

                    } else {
                        errorHandler(data, 'get-sectors');
                    }

                } else {
                    errorHandler(data, 'get-sectors');
                }
            },
            timeout: 30000
        });

        function successFn(data) {
            //сектора с сервера
            WIDGET_DATA.sectors = data?.sectors;

            if(data?.authLink){
                WIDGET_DATA.authLink = data?.authLink;
            }

            //разметка секторов в виде DOM элементов
            WIDGET_DATA.sectorSvgObjects = renderArena(WIDGET_DATA.drawingOptions, WIDGET_DATA.disabledSectorsWithoutPopup, WIDGET_DATA.customVipSectors);

            //получаем номера секторов как DOM элементы
            $domElements.chooseSectorTextsSVG = $domElements.chooseSectorDrawing.find('text');

            //проверяем сектора на наличие свободных мест
            checkSectorsAvailable(WIDGET_DATA);

            //получаем мин и макс цену для слайдера
            WIDGET_DATA.maxPrice = findMaxPrice(WIDGET_DATA.sectors);
            WIDGET_DATA.minPrice = findMinPrice(WIDGET_DATA.sectors);

            //записываем значения по умолчанию для смены текста в фильтре при его применении на мобилке
            WIDGET_DATA.defaultMinPrice = +WIDGET_DATA.minPrice;
            WIDGET_DATA.defaultMaxPrice = +WIDGET_DATA.maxPrice;

            //если значения слайдера в куке есть и совпадают с текущим мин/макс->
            // устанавливаем значения в слайдер из куки и фльтруем сектора
            if (isCookiePricesCorrect()) {
                initSliders(WIDGET_DATA, $domElements, true);
                filterSectorsPrice(WIDGET_DATA.sliderFrom, WIDGET_DATA.sliderTo, WIDGET_DATA);

                //устанавливаем для мобильного фильтра текстовые границы (если мин/макс отличаются от текущего значения)
                checkMobileSlider();

            } else {
                //иначе - обнуляем значения слайдера в куке
                //сохраняем в куку мин/макс и текущее значение слайдера
                setCookie('minPrice', null);
                setCookie('maxPrice', null);
                setCookie('currentMin', null);
                setCookie('currentMax', null);

                initSliders(WIDGET_DATA, $domElements, false);
            }

            initChooseSectorHandlers();

            $(window).on('resize', () => {
                initChooseSectorHandlers();
            });

            checkSectorsCookie();

            //показываем ковидное сообщение через 2 секунды после инициализации
            setTimeout(() => {
                initCovidHandler($domElements, WIDGET_DATA.covidFlag);
            }, 2000);

            function checkSectorsCookie() {
                //проверяем, есть ли уже забронированные места
                if (WIDGET_DATA.userInfo.seatInReserve.length !== 0) {
                    //устанавливаем выбранный сектор из резервированных мест
                    const sectorIdFromReserve = +WIDGET_DATA.userInfo.seatInReserve[0].sector;
                    const $reservedSectorSVG = WIDGET_DATA.sectorSvgObjects.find(sectorSVG => {
                        if (sectorSVG.data('id') === sectorIdFromReserve) {
                            return sectorSVG
                        }
                    });

                    const reservedSectorColor = $reservedSectorSVG.data('color');
                    const reservedSectorName = $reservedSectorSVG.data('name');

                    WIDGET_DATA.chosenSector = {
                        id: sectorIdFromReserve,
                        name: reservedSectorName,
                        color: reservedSectorColor,
                        teamsInfo: WIDGET_DATA.matchInfo.teams
                    }

                    //перекидываем пользователя на выбор места
                    $domElements.covidBanner.remove();
                    WIDGET_DATA.previousPage = 'choose_sector';
                    route('choose_place');
                    return;
                }

                //проверяем, есть ли выбранный сектор в куке, в данных с сервера и имеет свободные места
                if (WIDGET_DATA.localState.chosenSector && checkCookieSectorAvailable(WIDGET_DATA.localState.chosenSector)) {
                    //устанавливаем выбранный сектор из куки
                    WIDGET_DATA.chosenSector = {
                        id: WIDGET_DATA.localState.chosenSector.id,
                        name: WIDGET_DATA.localState.chosenSector.name,
                        color: WIDGET_DATA.localState.chosenSector.color,
                        teamsInfo: WIDGET_DATA.matchInfo.teams
                    }

                    //перекидываем пользователя на выбор места
                    $domElements.covidBanner.remove();
                    WIDGET_DATA.previousPage = 'choose_sector';
                    route('choose_place');
                } else {
                    //очищаем все куки
                    setCookie('chosen_sector', null);

                    hidePreloader();
                }
            }

            function checkCookieSectorAvailable(chosenSectorCookie) {
                const cookieSectorId = chosenSectorCookie.id;
                const cookieSectorInServerData = WIDGET_DATA.sectors.filter(sector => +sector.id === cookieSectorId)[0];
                const cookieSectorMinPrice = +cookieSectorInServerData?.minPrice;
                const cookieSectorMaxPrice = +cookieSectorInServerData?.maxPrice;
                const cookieSectorPriceCorrect = cookieSectorMinPrice !== 0 || cookieSectorMaxPrice !== 0;

                return cookieSectorInServerData && +cookieSectorInServerData.freePlaces !== 0 && cookieSectorPriceCorrect;
            }

            function isCookiePricesCorrect() {
                const cookieMin = getCookie('minPrice');
                const cookieMax = getCookie('maxPrice');

                return cookieMin && cookieMax && cookieMin === +WIDGET_DATA.minPrice && cookieMax === +WIDGET_DATA.maxPrice;
            }

        }
    }

    function setInitWidgetData() {
        //устанавливаем id пользователя, id матча
        const getParameters = window.location.search;
        let matchId = 0;

        //matchId берём из гет параметра
        if (getParameters.includes('matchId')) {
            matchId = new URLSearchParams(window.location.search).get("matchId");
        }

        //если есть гет параметр sector_access, даём пользователю доступ только на сектор b530 и 12 (металлург)
        if(getParameters.includes('custom_sector_access')){
            WIDGET_DATA.customSectorAccess = true;
        }

        //если есть гет параметр sector_access, даём пользователю доступ только на сектор b530 b 12 (металлург)
        if(getParameters.includes('custom_sector_access')){
            setCookie('minPrice', null);
            setCookie('maxPrice', null);
            setCookie('currentMin', null);
            setCookie('currentMax', null);
            setCookie('chosen_sector', null);
            setCookie('chosen_tickets_current_page', null);
            setCookie('deadline', null);

            WIDGET_DATA.customSectorAccess = true;

        }else{
            //Если доступ без гет параметра - смотрим наличие выбранного сектора в куках.
            //Если там b530 (122188) и 12 (металлург) 19846 -> обнуляем куку выбранного сектора и страницы, на которой остановился пользователь
            const chosenSectorCookie = getCookie('chosen_sector');

            if(chosenSectorCookie && (+chosenSectorCookie?.id === 122188 || +chosenSectorCookie?.id === 19846)){
                setCookie('chosen_sector', null);
                setCookie('chosen_tickets_current_page', null);
            }
        }

        WIDGET_DATA.matchId = +matchId;
    }

    function setDomElements() {
        //основные блоки
        $domElements.body = $('body');
        $domElements.contentBlock = $('#ticket_system__content_block');
        $domElements.returnBlock = $('#ticket_system__return_block');
        $domElements.headerMatchInfo = $('#ticket_system__match');
        $domElements.firstTeamLogo = $('[data-ticket-system__first-team-logo]');
        $domElements.secondTeamLogo = $('[data-ticket-system__second-team-logo]');
        $domElements.teams = $('[data-ticket-system__match-name]');
        $domElements.matchDate = $('[data-ticket-system__match-date]');
        $domElements.sliderMin = $('.ticket-system__slider-min');
        $domElements.sliderMax = $('.ticket-system__slider-max');
        $domElements.zoomBlock = $('#ticket_system_zoom');
        $domElements.zoomIn = $domElements.zoomBlock.find('.ticket-system__zoom-icon-right');
        $domElements.zoomOut = $domElements.zoomBlock.find('.ticket-system__zoom-icon-left');
        $domElements.zoomInIcon = $domElements.zoomIn.find('.ticket-system__icon__zoom-in');
        $domElements.zoomOutIcon = $domElements.zoomOut.find('.ticket-system__icon__zoom-out');
        $domElements.filterDesktop = $('#ticket_system__filter_desktop');
        $domElements.filterMobileText = $('#ticket_system_filter_text');
        $domElements.placesWrapper = $('[data_ticket_system-choose-place-render]');
        $domElements.placesRender = $('#ticket_system_choose_places');
        $domElements.placesRowsWrapper = $('[data-ticket-system__choose-places-row-wrapper]');
        $domElements.chooseSectorDrawing = $('#ticket_system_choose_sector_drawing');
        $domElements.orderInfoTicketsWrapper = $('#ticket_system__order_info_tickets_wrapper');
        $domElements.orderInfoParkingSection = $('[data-ticket_system-order-info-parking]');
        $domElements.orderInfoServicesSection = $('[data-ticket_system-order-info-services]');
        $domElements.orderInfoNoTicketsMessage = $('.ticket-system__order-info-no-tickets-block');
        $domElements.orderInfoNextStepButton = $('[data-ticket_system-submit-order-step]');
        $domElements.orderInfoBonusesValue = $('.ticket-system__plus-points');
        $domElements.orderInfoToggleBonuses = $('[data-use-user-points-block]');
        $domElements.orderInfoEnterUserProfileBlock = $('[data-enter-profile-block]');
        $domElements.bonusesWriteOff = $('[data-bonuses-write-off]');
        $domElements.bonusesAll = $('[data-bonuses-all]');
        $domElements.chooseSectorDrawingBlock = $('.ticket-system__choose-sector-drawing-block');
        $domElements.contentTitle = $('[data-ticket-system__main-title]');
        $domElements.submitOrderForm = $('[data-ticket-system-submit-order-form]');
        $domElements.submitOrderEmailOrPhoneInput = $('#phone_or_email_input');
        $domElements.submitOrderFirstNameInput = $('#first_name_input');
        $domElements.submitOrderLastNameInput = $('#last_name_input');
        $domElements.submitOrderFullPrice = $('[data-ticket-system-submit-order-full-price]');
        $domElements.submitOrderInputsWrapper = $('[data-ticket-system__submit-order-tickets-wrapper]');
        $domElements.checkPasswordBlock = $('[data-ticket-system-check-password-block]');
        $domElements.errorPage = $('#ticket_system_error_page');
        $domElements.errorButton = $('[data-ticket-system-error-button]');
        $domElements.ticketsPage = $('#ticket_system_tickets_page');
        $domElements.ticketsPageButton = $('[data-ticket-system-tickets-page-button]');
        $domElements.ticketsPageModal = $('[data-ticket-system__tickets-page-modal]');
        $domElements.ticketsPageModalTitle = $('.ticket-system__tickets-page-modal-title');
        $domElements.ticketsPageModalForm = $('[data-ticket-system__tickets-page-modal-form]');
        $domElements.ticketsPageModalInput = $('#email_for_sending_ticket');
        $domElements.ticketsPageModalPreloader = $('[data-ticket-system__tickets-page-modal-preloader]');
        $domElements.ticketsPageModalFormSuccess = $('[data-ticket-system__tickets-page-modal-success]');
        $domElements.ticketsPageModalFormError = $('[data-ticket-system__tickets-page-modal-error]');
        $domElements.deadlineTimer = $('.ticket-system___deadline-timer');
        $domElements.deadlineTimerValue = $('[data-ticket-system-timer-value]');
        //попапы
        $domElements.popupChooseSector = $('#ticket_system__popup_choose_sector');
        $domElements.popupChooseSectorContent = $domElements.popupChooseSector.find('.ticket-system__popup-choose-sector-content');
        $domElements.popupChooseSectorClose = $('[data-close-choose-sector-popup]');
        $domElements.popupFilter = $('#ticket_system__popup_filter');
        $domElements.popupChoosePlace = $('#ticket_system__popup_choose_place');
        $domElements.popupChoosePlaceContent = $domElements.popupChoosePlace.find('.ticket-system__popup-choose-sector-content');
        $domElements.popupTickets = $('#ticket_system__popup_tickets');
        $domElements.popupTicketsWrapper = $('#ticket-system__popup-tickets-wrapper');
        $domElements.modalChoosePlaceWarning = $('#ticket_system__choose-place-warning-modal');
        $domElements.modalSendFanId = $('#ticket_system__fan-id-modal');
        $domElements.modalDeadlineTimer = $('#ticket_system__deadline__modal');
        $domElements.covidBanner = $('#ticket_system_covid');
        $domElements.preloader = $('#ticket_system_preloader');
        $domElements.errorPageText = $('[data-ticket_system-error-message]');
        $domElements.modalPromocode = $('#ticket_system__promocode__modal');
        $domElements.activatePromocodeBlock = $('.ticket-system__promocode-activate');
        $domElements.closePromocodeModal = $('[data-ticket-system-promocode-close-modal]');
    }

    //заполнение данных пользователя
    function setUserData(userData) {
        //если пришла почта или телефон - ставим флаг, что пользователь авторизован в лк и показываем бонусы
        if (userData?.phone_or_email) {
            WIDGET_DATA.userInfo.phone_or_email = userData.phone_or_email;
            WIDGET_DATA.isUserAuthorized = 1;
            $domElements.orderInfoEnterUserProfileBlock.hide();

            //иначе скрываем бонусы и промо, показываем предложение о входе в лк
        } else {
            $domElements.orderInfoToggleBonuses.hide();
            $('.ticket-system__plus-points').hide();
            $('.ticket-system__order-info__promocode-wrapper').hide();
        }

        if (userData?.lastName) {
            WIDGET_DATA.userInfo.lastName = userData.lastName;
        }

        if (userData?.firstName) {
            WIDGET_DATA.userInfo.firstName = userData.firstName;
        }

        if (userData?.hasOwnProperty('seatInReserve')) {
            WIDGET_DATA.userInfo.seatInReserve = userData.seatInReserve.sort(sortByDiscount());

            function sortByDiscount() {
                return (a, b) => a['price'] > b['price'] ? 1 : -1;
            }
        }

        //костыль - пока без бонусов
        /*if(!userData?.points && +userData?.points === 0){
            $domElements.orderInfoToggleBonuses.hide();
            $domElements.orderInfoBonusesValue.hide();
            $domElements.orderInfoEnterUserProfileBlock.hide();
        }*/

        //костыль - пока без бонусов
       /* $domElements.orderInfoToggleBonuses.hide();
        $domElements.orderInfoBonusesValue.hide();
        $domElements.orderInfoEnterUserProfileBlock.hide();*/
    }

    //заполнение блоков хедера данными виджета
    function setHeaderData(matchInfo) {
        //если абонемент
        if (WIDGET_DATA.isAbonement) {
            $domElements.firstTeamLogo.css('background-image', `url(${WIDGET_DATA.abonementData.img})`).css('height', '40px');
            $domElements.teams.text(`${WIDGET_DATA.abonementData.name}`).css('font-size', '14px');
            $domElements.matchDate.text(`${WIDGET_DATA.abonementData.year}`).css('font-size', '12px');
            $('[data-ticket-system__second-team-logo]').hide();

            //если билеты на обычный матч
        } else {
            $domElements.firstTeamLogo.css('background-image', `url(${matchInfo?.teams[0].image})`);
            $domElements.secondTeamLogo.css('background-image', `url(${matchInfo?.teams[1].image})`);
            $domElements.teams.text(`${matchInfo?.teams[0].name} - ${matchInfo?.teams[1].name}`);
            $domElements.matchDate.text(`${matchInfo?.date}`);
        }

        $domElements.contentTitle.text(translator('Выберите сектор',WIDGET_DATA.lang));
    }

    //навигация по виджету
    function navigateTo(page) {
        $domElements.contentBlock.find('[data-ticket-system-page]').hide();
        WIDGET_DATA.currentPage = page;

        if (page === 'choose_sector') {
            if (WIDGET_DATA.sectors.length === 0) {
                getSectorsData();
            }
            renderRoute('choose_sector', $domElements, WIDGET_DATA)
            resetZoom();

        } else if (page === 'choose_place') {
            //если переход с "Выбор сектора" => обнуляем выбранные ранее места и делаем запрос
            if (WIDGET_DATA.previousPage === 'choose_sector') {
                WIDGET_DATA.chosenTickets.length = 0;
                $domElements.popupTicketsWrapper.empty();
                getPlaces();

            } else {
                hidePreloader();
                renderTicketsPopup($domElements, WIDGET_DATA);
            }

            renderRoute('choose_place', $domElements, WIDGET_DATA)
            resetZoom();

        } else if (page === 'order_info') {
            renderTicketsInfo(WIDGET_DATA);
            /*if (WIDGET_DATA.parkingProducts.length) {
                renderParking(WIDGET_DATA);
            }

            if (WIDGET_DATA.serviceProducts.length) {
                renderServices(WIDGET_DATA);
            }*/

            initOrderInfoHandlers();

            //если переход не с Подтверждения заказа и пользователь зарегистрирован
/*            if (WIDGET_DATA.isUserAuthorized) {

            }*/
            // Пока скрыл
            getPoints();

            renderRoute('order_info', $domElements, WIDGET_DATA);

        } else if (page === 'submit_order') {
            const regex = /[^а-яА-Я]/g;
            showPreloader();
            renderSubmitOrderTickets(WIDGET_DATA, $domElements);
            renderRoute('submit_order', $domElements, WIDGET_DATA);

            //проверяем есть ли данные для заполнения полей на Оформлении заказа
            //телефон/email
            if (WIDGET_DATA.userInfo.phone_or_email) {
                //если это почта
                if (isNan(+WIDGET_DATA.userInfo.phone_or_email)) {
                    $domElements.submitOrderEmailOrPhoneInput.val(WIDGET_DATA.userInfo.phone_or_email);
                    WIDGET_DATA.currentPhoneOrEmailMask = 'email';

                    //если это телефон
                } else {
                    //+7 (999) 999-99-99
                    const purePhoneValue = WIDGET_DATA.userInfo.phone_or_email;
                    let correctPhoneValue = `+7 (${purePhoneValue[0]}${purePhoneValue[1]}${purePhoneValue[2]}) ${purePhoneValue[3]}${purePhoneValue[4]}${purePhoneValue[5]}-${purePhoneValue[6]}${purePhoneValue[7]}-${purePhoneValue[8]}${purePhoneValue[9]}`

                    $domElements.submitOrderEmailOrPhoneInput.val(correctPhoneValue);
                    WIDGET_DATA.currentPhoneOrEmailMask = 'phone';
                }

                $domElements.submitOrderEmailOrPhoneInput.parent('label').removeClass('empty').addClass('success');
            }

            //фамилия
            if (WIDGET_DATA.userInfo.lastName) {
                $domElements.submitOrderLastNameInput.val(WIDGET_DATA.userInfo.lastName);
                $domElements.submitOrderLastNameInput.parent('label').removeClass('empty').addClass('success');

            }

            //имя
            if (WIDGET_DATA.userInfo.firstName) {
                $domElements.submitOrderFirstNameInput.val(WIDGET_DATA.userInfo.firstName);
                $domElements.submitOrderFirstNameInput.parent('label').removeClass('empty').addClass('success');

            }

            if (!WIDGET_DATA.isSubmitOrderPageInited) {
                initSubmitOrderHandlers();
            }

            //каждый раз инитим обработку имени фамилии на инпутах для каждого билета (ререндер)
            $('[data-ticket-system__submit-order-tickets-wrapper] input').on('input', function () {
                $(this).val($(this).val().replace(regex, ''));
            });

            //валидируем инпут при его изменении
            $domElements.submitOrderForm.find('input.input-text').on('change', e => {
                const $changedInput = $(e.currentTarget)
                validateField($changedInput);
                return false;
            });

            hidePreloader();
            WIDGET_DATA.isSubmitOrderPageInited = 1;

            //финальный экран билетами
        } else if (page === 'tickets_page') {
            renderRoute('tickets_page', $domElements, WIDGET_DATA);

            //страница с ошибкой
        } else if (page === 'error_page') {
            renderRoute('error_page', $domElements, WIDGET_DATA);
        }

        $domElements.contentBlock.find(`[data-ticket-system-page='${page}']`).show();
    }

    function initWidgetHandlers() {
        //открытие фильтра
        $domElements.body.on('click', '#ticket_system_filter', () => {
            showFilterPopup();
            $domElements.body.css('overflow', 'hidden');
            return false;
        });

        //закрытие фильтра
        $domElements.body.on('click', '.ticket-system__popup-filter-close-block', () => {
            hideFilterPopup();
            $domElements.body.css('overflow', 'auto');
            return false;
        });

        //применение фильтров popup при клике на "Применить"
        $domElements.body.on('click', '[data-ticket-system-apply-popup-filters]', () => {

            filterSectorsPrice(WIDGET_DATA.sliderFrom, WIDGET_DATA.sliderTo, WIDGET_DATA);
            filterPlacesPrice(WIDGET_DATA);
            hideFilterPopup();

            //если есть выбранные билеты -> открываем попап выбранных билетов
            if (WIDGET_DATA.chosenTickets.length !== 0) {
                setTimeout(() => {
                    $domElements.popupTickets.addClass('ticket-system__popup-tickets-active');
                }, 200);
            }

            //если текущее значение фильтра отличается от дефолтного -> меняем текст "Фильтры" на ценовой диапазон
            //иначе ставим "Фильтры"
            checkMobileSlider();

            $domElements.body.css('overflow', 'auto');
        });

        //клик по кнопке "Продолжить" в popup сектора
        $domElements.body.on('click', '[data-ticket-system__choose-place-step]', () => {
            showPreloader();
            //убираем ковидное сообщение
            $domElements.covidBanner.remove();
            WIDGET_DATA.previousPage = 'choose_sector';
            //сохраняем сектор в куку
            setCookie('chosen_sector', WIDGET_DATA.chosenSector);
            route('choose_place');
        });

        //возврат на предыдущий шаг
        $domElements.returnBlock.on('click', () => {
            //если блок подтверждения логина активен
            if (WIDGET_DATA.currentPage === 'submit_order' && WIDGET_DATA.isSubmitLoginSection === 1) {
                //меняем загловок, показываем инпуты
                $domElements.checkPasswordBlock.addClass('ticket-system__hide');
                $domElements.contentTitle.text(translator('Оформление заказа',WIDGET_DATA.lang));
                $('[data-ticket-system-submit-order-inputs-wrapper]').removeClass('ticket-system__hide');
                $('[data-ticket-system-submit-order-check-password-text]').html('');
                $('[data-ticket-system-submit-order-submit-form]').removeClass('ticket-system__hide');
                $('.ticket-system__submit-order-description').removeClass('ticket-system__hide');
                $domElements.submitOrderInputsWrapper.show();
                $('#check_password').val('');
                $('#check_password').parents('.field').removeClass('success').addClass('empty');

                $('[data-tickets-system-timer]').text(``);
                //выключаем счетчик
                clearInterval(WIDGET_DATA.timerInterval);
                WIDGET_DATA.isSubmitLoginSection = 0;

                return;
            }

            if (WIDGET_DATA.previousPage === 'order_info' && WIDGET_DATA.currentPage === 'order_info') {
                WIDGET_DATA.previousPage = 'choose_place';


            } else if (WIDGET_DATA.previousPage === 'choose_place' && WIDGET_DATA.currentPage === 'choose_place') {
                WIDGET_DATA.previousPage = 'choose_sector';

                if(WIDGET_DATA.userInfo.seatInReserve.length !== 0){
                    deleteBooking(WIDGET_DATA.userInfo.seatInReserve, '', true);
                    WIDGET_DATA.userInfo.seatInReserve.length = 0;
                }

            } else if (WIDGET_DATA.previousPage === 'choose_sector' && WIDGET_DATA.currentPage === 'choose_place') {
                //при возврате с Выбора мест на Выбор сектора -> обнуляем куки по сектору и местам
                if(WIDGET_DATA.userInfo.seatInReserve.length !== 0){
                    deleteBooking(WIDGET_DATA.userInfo.seatInReserve, '', true);
                    WIDGET_DATA.userInfo.seatInReserve.length = 0;
                }
                setCookie('chosen_sector', null);

            }

            //если мы сразу попали на Инф о заказе и в куке указана эта страница -> меняем на выбор места
            if (getCookie('chosen_tickets_current_page') === 'submit_order') {
                setCookie('chosen_tickets_current_page', 'choose_place');
            }

            route(WIDGET_DATA.previousPage);

            //если возвращаемся с Ваш заказа с пустыми билетами
            if (WIDGET_DATA.previousPage === 'choose_place' && WIDGET_DATA.currentPage === 'order_info') {
                //убираем сообщение и активируем кнопку перехода на Подтверждении заказа
                setTimeout(() => {
                    $domElements.orderInfoNoTicketsMessage.addClass('ticket-system__hide');
                    $domElements.orderInfoNextStepButton.removeClass('ticket-system__button--disabled');
                }, 50)
            }
        });

        //позиционирование десктопных попапов
        $(window).on('mousemove', (e) => {
            if (isDesktop()) {
                setPopupPosition(e, $domElements.popupChooseSector);
                setPopupPosition(e, $domElements.popupChoosePlace);
            }
        });

        //при ресайзе на десктоп сбрасываем зум
        $(window).on('resize', () => {
            if (isDesktop() && WIDGET_DATA.zoomValue !== 100) {
                setTimeout(() => {
                    resetZoom();
                }, 300)
            }
        });

        //сворачивание попапа с билетами на мобилке
        $domElements.body.on('click', '#ticket-system__popup-tickets-roll-handler', () => {
            $domElements.popupTickets.toggleClass('ticket-system__popup-tickets-rolled');
        });

        //возвращение на главный экран со страницы с билетами
        $domElements.body.on('click', '[data-ticket-system-tickets-page-button]', () => {
            $domElements.ticketsPage.css('display', 'none');

            //редирект на изначальную страницу с виджетом
            window.location.href = window.location.origin + window.location.pathname + `?matchId=${WIDGET_DATA.matchId}`;
        });

        //закрытие модалки-предупреждения при попытке выбора более 4 билетов
        $domElements.body.on('click', '[data-ticket-system__choose-place-warning-modal-close]', () => {
            $domElements.modalChoosePlaceWarning.removeClass('active-effect');
            setTimeout(() => {
                $domElements.modalChoosePlaceWarning.removeClass('active');
                $domElements.body.css('overflow', 'auto');
            }, 200)
        });

        //переход на страницу выбора матча
        $domElements.body.on('click', '[data-ticket-system__return-to-choose-match]', () => {
            if (AJAX_MODE === 'test') {
                window.location.href = 'https://ks.internetlab.ru/tickets/';
            }

            if (AJAX_MODE === 'prod') {
                window.location.href = 'https://pfcks.ru/tickets/';
            }

        });

        //обработчик отправки пароля для подтверждения email/телефона
        $domElements.body.on('click', '[data-ticket-system-submit-order-send-password]', () => {
            checkPassword();
        });

        //обработка ввода подтверждения пароля
        $('#check_password').on('blur', () => {
            validateCheckPasswordInput();
        });
        $('#check_password').on('focus', () => {
            $('#check_password').parents('.field').removeClass('error');
            $('[data-ticket-system__submit-order-check-password-error-block]').hide();
        });

        $('#check_password').on('input', () => {
            $('#check_password').val($('#check_password').val().replace(/[^0-9.]/g, ''));
        });


        //клик по повторной отправке кода
        $domElements.body.on('click', '[data-tickets-system-timer].finished', () => {
            $('[data-ticket-system__submit-order-check-password-error-block]').hide();
            sendPassword();
        });

        //тогглер бонусов
        $domElements.body.on('click', '[data-use-user-points-block]', function (e) {
            e.preventDefault();
            const $switcher = $(this).find('.switcher-gray');
            $('.ticket-system__plus-points').toggleClass('ticket-system__hide');
            $switcher.toggleClass('active');

            if($switcher.hasClass('active') && WIDGET_DATA.promocodeData.isPromocodeAccepted){
                const promocodeVal = $('#promocode_input').val().trim('');

                validatePromocode(promocodeVal, false);

            }else{
                calculateFullPrice(WIDGET_DATA);
            }
        });

        //открытие модалки по условия конф и политики
        $domElements.body.on('click', '.ticket-system__submit-order-description span', function (e) {
            $domElements.body.css('overflow', 'hidden');
            $('#ticket_system__politic').addClass('active');
            setTimeout(() => {
                $('#ticket_system__politic').addClass('active-effect');
            }, 50);
        });

        //закрытие политики
        $domElements.body.on('click', '.ticket-system__politic_modal_close_wrapper-politic', function (e){
            $('#ticket_system__politic').removeClass('active-effect');
            setTimeout(() => {
                $('#ticket_system__politic').removeClass('active');
            }, 50);
            $domElements.body.css('overflow', 'auto');
        });

        //отправка fanid
        $domElements.body.on('click', '[data-ticket-system-tickets-page-save-tickets]', function (e){
            if(validateField($('#fan_id_input'))){
                bookTicketWithFanIn();
            }
        });

        //контроль инпута fanid
        $('#fan_id_input').on('input', function (){
            $(this).parents('.field').removeClass('error');
        });

        //закрытие модалка fan-id
        $domElements.body.on('click', '[data-ticket-system-fanid-close-modal]', function (e){
            $domElements.modalSendFanId.removeClass('active-effect');
            setTimeout(() => {
                $domElements.modalSendFanId.removeClass('active');
                $domElements.modalSendFanId.removeClass('error');
                $('#fan_id_input').val('');
                $('#fan_id_input').parents('.field').removeClass('success').addClass('empty');
            }, 50);
            $domElements.body.css('overflow', 'auto');
        });

        //попытка отправить fanid ещё раз
        $domElements.body.on('click', '[data-ticket-system__fanid-try-again]', function (){
            $domElements.modalSendFanId.removeClass('error');
            $('#fan_id_input').val('');
            $('#fan_id_input').parents('.field').removeClass('success').addClass('empty');
        });

        //выбрать другое место при ошибке резервирования (забронировано и т.п., код ошибки 20115)
        $domElements.body.on('click', '[data-ticket-system__fanid-choose-different]',function (){
            $domElements.modalSendFanId.removeClass('active-effect');
            setTimeout(() => {
                $domElements.modalSendFanId.removeClass('active');
                $domElements.modalSendFanId.removeClass('error');
                $('#fan_id_input').val('');
                $('#fan_id_input').parents('.field').removeClass('success').addClass('empty');
            }, 50);
            $domElements.body.css('overflow', 'auto');
        });

        //отмена промокода
        $('.ticket-system__promocode-activated-promocode-delete-promocode').on('click', function () {
            WIDGET_DATA.promocodeData.min_value = null;
            WIDGET_DATA.promocodeData.discount_value = 0;
            WIDGET_DATA.promocodeData.discount_type = '';
            WIDGET_DATA.promocodeData.code = '';

            //ререндер попапа выбранных мест
            renderTicketsPopup($domElements, WIDGET_DATA);
            renderTicketsInfo(WIDGET_DATA);
        });

        $('#promocode_input').on('input', function (){
            const inputVal = $(this).val();
            $(this).val(`${inputVal.replace(/[А-Яа-яЁё]/g,'')}`);

            if(inputVal){
                $('.ticket-system__promocode-btn').removeClass('ticket-system__hide');
            }else{
                $('.ticket-system__promocode-btn').addClass('ticket-system__hide');
            }
        });

        //валидация промокода
        $('.ticket-system__promocode-btn').on('click', function (){
            const promocodeVal = $('#promocode_input').val().trim('');

            validatePromocode(promocodeVal, true);
        });

        //удаление промокода
        $('.ticket-system__del-promocode').on('click', function (){
            WIDGET_DATA.isPromocodesAvailable = false;
            WIDGET_DATA.promocodeData.isPromocodeAccepted = false;
            WIDGET_DATA.promocodeData.code = null;

            handlePromocode();
        });

        $('[data-ticket-system__order-info-block-prices-roll-trigger]').on('click', function (){
            $('.ticket-system__order-info-block-prices').toggleClass('active-rolled-mob');
            $('.ticket-system__pxl-mobile').toggleClass('ticket-system__hide');
            $('html').toggleClass('ticket-sysyem-modal-active')
        });

        //зум и обработчики для страницы с успешной оплатой билетов
        initZoomHandler();

        function bookTicketWithFanIn(){
            $domElements.modalSendFanId.removeClass('error');
            $domElements.modalSendFanId.addClass('loading');

            let isTicketWithDIscount = false;

            //если количество доступных для покупки
            // билетов со скидкой больше тек кол-ва выбранных билетов -> указываем, что бронируем билет со скидкой
            if(WIDGET_DATA.chosenTickets.length < WIDGET_DATA.availableDiscountTickets){
                isTicketWithDIscount = true;
            }

            const ajaxData = {
                matchId: WIDGET_DATA.matchId,
                fanId: $('#fan_id_input').val(),
                chosenPlaces: [
                    {
                        seatId: +WIDGET_DATA.currentChosenTicket.id,
                        zoneId: +WIDGET_DATA.currentChosenTicket.zoneId,
                        categoryId: +WIDGET_DATA.currentChosenTicket.categoryId,
                        discount: isTicketWithDIscount
                    }
                ]
            };

            WIDGET_DATA.lastEnteredFanId = $('#fan_id_input').val();

            $.ajax({
                url: `${AJAX_URL}/ajax/createBooking/`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ajaxData),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    if (isDataCorrect(data) && data?.payload?.ResultCode !== '20115') {
                        successFn(ajaxData.fanId);

                    } else {
                        errorFn(data);
                    }
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.fanId;
                        if (isDataCorrect(data) && data?.payload?.ResultCode !== '20115') {
                            successFn(ajaxData.fanId);

                        } else {
                            errorFn(data);
                        }
                    } else {
                        errorFn(data);
                    }
                },
                timeout: 30000
            });

            function successFn(fanId){
                $domElements.modalSendFanId.removeClass('active-effect');
                setTimeout(() => {
                    $domElements.modalSendFanId.removeClass('active');
                }, 50);
                $domElements.body.css('overflow', 'auto');
                $domElements.modalSendFanId.removeClass('loading');
                $('#fan_id_input').val('');
                $('#fan_id_input').parents('.field').removeClass('success').addClass('empty');
                addTicketToChosen(WIDGET_DATA.currentChosenTicket, fanId);
                //записываем в куку время бронирования
                const dateWithTimeZone = new Date();
                dateWithTimeZone.setHours(dateWithTimeZone.getHours() - new Date().getTimezoneOffset() / 60);
                dateWithTimeZone.setMinutes(dateWithTimeZone.getMinutes() + 30);
                setCookie('deadline', dateWithTimeZone);
                initDeadlineTimer('extend');
            }

            function errorFn(data){

                //ошибка бронирования - уже зарезервированно
                if(data?.payload?.ResultCode === '20115'){
                    $domElements.modalSendFanId.find('.ticket_system__fan-id-modal-error').html(`
                        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 80px;height: 80px;">
                            <circle cx="40.5" cy="40.5" r="40.5" fill="#FF5C5C"/>
                            <path d="M57.3322 24L32.1239 49.2083L24 57.3324" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M24 24L49.2083 49.2084L57.3324 57.3323" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="ticket-system__fanid-error-title">${translator('Ошибка',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text">${translator('К сожалению, данное место уже забронировано, выберите другое',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__button--darkCyan" data-ticket-system__fanid-choose-different>${translator('Выбрать место',WIDGET_DATA.lang)}</div> 
                    `);

                }else{
                    $domElements.modalSendFanId.find('.ticket_system__fan-id-modal-error').html(`
                        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 80px;height: 80px;">
                            <circle cx="40.5" cy="40.5" r="40.5" fill="#FF5C5C"/>
                            <path d="M57.3322 24L32.1239 49.2083L24 57.3324" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M24 24L49.2083 49.2084L57.3324 57.3323" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="ticket-system__fanid-error-title">${translator('Ошибка',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text">${translator('Информация не найдена или введена не корректно.',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text left-align-text">${translator('Введите:',WIDGET_DATA.lang)}</div>
                         <div class="ticket-system__fanid-error-text ticket-system-list-style">
                            <div class="ticket-system__fanid-error-text ticket-system__no-margin-top">${translator('№ карты болельщика в формате 123456789 (9 символов). Карту болельщика можно оформить в личном кабинете на сайте', WIDGET_DATA.lang)} <a target="_blank" href="https://www.gosuslugi.ru/fancard">${translator('Госуслуги', WIDGET_DATA.lang)}</a>.</div>
                        </div>
                        <div class="ticket-system__fanid-error-text">${translator('Если вы указали все верно, но появляется ошибка - напишите на ', WIDGET_DATA.lang)}<a href="mailto:tickets@ks-samara.com">tickets@ks-samara.com</a>.</div>
                        <div class="ticket-system__button--darkCyan" data-ticket-system__fanid-try-again>${translator('Попробовать ещё раз',WIDGET_DATA.lang)}</div>
                    `);
                }

                $domElements.modalSendFanId.removeClass('loading');
                $domElements.modalSendFanId.addClass('error');
            }
        }

        function initZoomHandler() {
            let zoomStep = 50;

            $domElements.zoomOut.on('click', () => {
                if (WIDGET_DATA.zoomValue === 100) {
                    return false;
                }

                const renderBlockWidth = $domElements.placesWrapper.width();
                WIDGET_DATA.zoomValue -= zoomStep;

                $domElements.chooseSectorDrawingBlock.css('overflow', 'auto');
                $domElements.placesRender.scrollLeft(renderBlockWidth);
                $domElements.zoomInIcon.css('background-color', '#0063FF');

                if (WIDGET_DATA.zoomValue === 100) {
                    $domElements.chooseSectorDrawing.css('width', '100%');
                    $domElements.zoomOutIcon.css('background-color', '#C5D2E8');
                    $domElements.placesRender.removeClass('ticket-system__choose-places-zoom-x1_5');
                    zoomPlaces(1);

                } else if (WIDGET_DATA.zoomValue === 150) {
                    $domElements.chooseSectorDrawing.css('width', '150%');
                    $domElements.placesRender.removeClass('ticket-system__choose-places-zoom-x2');
                    zoomPlaces(1.2);
                }
            })

            $domElements.zoomIn.on('click', () => {
                if (WIDGET_DATA.zoomValue === 200) {
                    return false;

                } else if (WIDGET_DATA.zoomValue === 100) {
                    $domElements.chooseSectorDrawing.css('width', '150%');
                    $domElements.placesRender.addClass('ticket-system__choose-places-zoom-x1_5');
                    zoomPlaces(1.2);

                } else if (WIDGET_DATA.zoomValue === 150) {
                    $domElements.chooseSectorDrawing.css('width', '200%');
                    $domElements.placesRender.addClass('ticket-system__choose-places-zoom-x2');
                    zoomPlaces(1.5);
                }

                const renderBlockWidth = $domElements.placesWrapper.width();

                $domElements.chooseSectorDrawingBlock.css('overflow', 'auto');
                WIDGET_DATA.zoomValue += zoomStep;
                $domElements.zoomOutIcon.css('background-color', '#0063FF');

                $domElements.placesRender.scrollLeft(renderBlockWidth);

                if (WIDGET_DATA.zoomValue === 200) {
                    $domElements.zoomInIcon.css('background-color', '#C5D2E8');
                }
            })
        }

        function showFilterPopup() {
            $domElements.popupFilter.addClass('ticket-system__popup-filter-show');
            setTimeout(() => {
                $domElements.popupFilter.addClass('ticket-system__popup-filter-show-effect');
            }, 5);
        }

        function hideFilterPopup() {
            $domElements.popupFilter.removeClass('ticket-system__popup-filter-show-effect');
            setTimeout(() => {
                $domElements.popupFilter.removeClass('ticket-system__popup-filter-show');
            }, 400);
        }
    }

    function initChooseSectorHandlers() {

        WIDGET_DATA.sectorSvgObjects.forEach((item) => {
            item.off('click');
            item.off('mouseenter');
            item.off('mouseleave');

            if (isDesktop()) {
                item
                    .on('mouseenter', () => {
                        handlerMouseenter(item);
                    })
                    .on('mouseleave', () => {
                        handlerMouseleave(item, false);
                    })
                    .on('click', () => {
                        handlerClick(item);
                    });

            } else {
                item.on('click', () => {
                    handlerClickMobile(item);
                    return false;
                });
            }
        });

        //закрытие popup
        $domElements.body.on('click', '[data-close-choose-sector-popup]', () => {
            const $clickedSector = WIDGET_DATA.sectorSvgObjects.find(sector => sector.data('id') === WIDGET_DATA.chosenSector.id);
            handlerMouseleave($clickedSector, false);
            return false;
        });

        function handlerMouseenter(item) {
            const freePlaces = +item.data('freePlaces');
            const id = item.data('id');
            const isPressSector = id === 'press';
            const sectorId = item.data('id');
            const sectorName = item.data('name');
            const sectorColor = item.data('color');

            //если ультравип - не выводим попап
            if(WIDGET_DATA.disabledSectorsWithoutPopup.includes(+sectorId)){
                return
            }

            if (freePlaces !== 0 && !isPressSector) {
                WIDGET_DATA.sectorSvgObjects.forEach(sector => {
                    if (+sector.data('freePlaces') !== 0 && sector.data('id') !== id && checkSectorInSliderPrice(sector)) {
                        sector.animate({duration: 300, when: 'now', delay: 100}).attr({fill: '#2E416F'});
                    }
                })
            }

            if (freePlaces !== 0 && !isPressSector) {
                $domElements.chooseSectorTextsSVG.each((_, textDOMElement) => {
                    const $text = $(textDOMElement);
                    const textId = $text.data('id');

                    if (textId !== id) {
                        $text.animate({duration: 300, when: 'now', delay: 100}).attr({fill: 'white'});
                    }
                });

                //устанавливаем выбранный сектор
                WIDGET_DATA.chosenSector = {
                    id: sectorId,
                    name: sectorName,
                    color: sectorColor,
                    teamsInfo: WIDGET_DATA.matchInfo.teams
                }
            }

            setDataPopup(item);
            showPopup();
        }

        function handlerMouseleave(item, isMobile) {
            const freePlaces = item.data('freePlaces');
            const id = item.data('id');

            if (freePlaces !== '0') {
                WIDGET_DATA.sectorSvgObjects.forEach(sector => {
                    if (+sector.data('freePlaces') !== 0 && sector.data('id') !== id && checkSectorInSliderPrice(sector)) {
                        sector.animate({
                            duration: 300,
                            when: 'now',
                            delay: 100
                        }).attr({fill: `${sector.data('color')}`});
                    }
                })
            }

            $domElements.chooseSectorTextsSVG.each((_, textDOMElement) => {
                const $text = $(textDOMElement);
                const defaultTextColor = $text.data('color');

                //меняем цвет для всех номеров секторов кроме того на который навелись, секторов в продаже и в границах цен слайдера
                if (isTextNeedToChangeColor($text)) {
                    $text.animate({duration: 300, when: 'now', delay: 100}).attr({fill: `${defaultTextColor}`});
                }
            });

            //если пришел флаг isMobile (в случае клика по другому сектору, когда есть активный)
            if (!isMobile) {
                hidePopup();
            }

            //удаляем выбранный сектор при уводе курсора
            $domElements.popupChooseSector.data('ticket-system-chosen-sector', {})

            function isTextNeedToChangeColor($text) {
                const textId = $text.data('id');
                const $sector = WIDGET_DATA.sectorSvgObjects.find(sector => sector.data('id') === textId);
                const freePlacesOnSector = $sector.data('freePlaces');

                return textId !== id && freePlacesOnSector !== 0 && checkSectorInSliderPrice($sector);
            }
        }

        function handlerClick(item) {

            if(WIDGET_DATA.authLink !== ''){
                window.location.href = WIDGET_DATA.authLink;
                return
            }

            if (isSectorAvailable(item)) {
                WIDGET_DATA.previousPage = 'choose_sector';
                route('choose_place');
                showPreloader();
                //сохраняем сектор в куку
                setCookie('chosen_sector', WIDGET_DATA.chosenSector);
                //убираем ковидное сообщение
                $domElements.covidBanner.remove();
            }

            if(WIDGET_DATA.customSectorAccess){
                WIDGET_DATA.previousPage = 'choose_sector';
                route('choose_place');
                showPreloader();
                //сохраняем сектор в куку
                setCookie('chosen_sector', WIDGET_DATA.chosenSector);
                //убираем ковидное сообщение
                $domElements.covidBanner.remove();
            }

            function isSectorAvailable(item) {
                const freePlaces = item.data('freePlaces');
                const minPrice = +item.data('minPrice');
                const maxPrice = +item.data('maxPrice');

                const isPressSector = item.data('id') === 'press';
                const isDisabled = WIDGET_DATA.disabledSectors.includes(item.data('id'));
                let isSectorInSliderBounds = true;

                if (minPrice && minPrice !== 0 && maxPrice && maxPrice !== 0) {
                    if ((minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo)
                        && (maxPrice < WIDGET_DATA.sliderFrom || maxPrice > WIDGET_DATA.sliderTo)) {
                        isSectorInSliderBounds = false;
                    }

                } else if (!minPrice || minPrice === 0) {
                    if (maxPrice < WIDGET_DATA.sliderFrom || maxPrice > WIDGET_DATA.sliderTo) {
                        isSectorInSliderBounds = false;

                    }

                } else if (!maxPrice || maxPrice === 0) {
                    if (minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo) {
                        isSectorInSliderBounds = false;

                    }
                }

                return freePlaces !== 0 && !isPressSector && !isDisabled && isSectorInSliderBounds;
            }
        }

        function handlerClickMobile(item) {
            const sectorId = item.data('id');

            if(WIDGET_DATA.authLink !== ''){
                window.location.href = WIDGET_DATA.authLink;
                return
            }

            //если ультравип - не выводим попап
            if(WIDGET_DATA.disabledSectorsWithoutPopup.includes(+sectorId)){
                return
            }

            const $clickedSector = WIDGET_DATA.sectorSvgObjects.find(sector => sector.data('id') === WIDGET_DATA.chosenSector.id);
            if ($clickedSector?.length) {
                handlerMouseleave($clickedSector, true);
            }

            handlerMouseenter(item);
        }

        function hidePopup() {
            if (isDesktop()) {
                $domElements.popupChooseSector.removeClass('ticket-system__popup-show ticket-system__popup-show-effect');
                clearPopup($domElements.popupChooseSectorContent);

            } else {
                $domElements.popupChooseSector.removeClass('ticket-system__popup-show-effect');
                setTimeout(() => {
                    $domElements.popupChooseSector.removeClass('ticket-system__popup-show');
                    clearPopup($domElements.popupChooseSectorContent);
                }, 200);
                $domElements.body.css('overflow', 'auto');

            }
        }

        function showPopup() {
            $domElements.popupChooseSector.addClass('ticket-system__popup-show');
            setTimeout(() => {
                $domElements.popupChooseSector.addClass('ticket-system__popup-show-effect');
            }, 5);
        }

        function clearPopup() {
            $domElements.popupChooseSectorContent.html('');
        }

        function setDataPopup(item = {}) {
            const id = item.data('id') || '';
            const name = item.data('name') || '';
            const color = item.data('color') || '';
            const freePlaces = item.data('freePlaces');
            const minPrice = +item.data('minPrice') || '';
            const maxPrice = +item.data('maxPrice') || '';
            const isDisabled = WIDGET_DATA.disabledSectors.includes(id);
            const isVIP = name === 'vip';

            getRightSectorPrice(minPrice)

            let minPriceClass = '';
            let maxPriceClass = '';
            let buttonDisabledClass = '';

            let placesFreeWord = WIDGET_DATA.lang === 'en' ? getRightTerm(+freePlaces, 'place', 'places', 'places') : getRightTerm(+freePlaces, 'место', 'места', 'мест');

            if (minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo) {
                minPriceClass = 'ticket-system__popup-choose-sector-price-value-not-in-slider-bounds';
            }

            if (maxPrice < WIDGET_DATA.sliderFrom || maxPrice > WIDGET_DATA.sliderTo) {
                maxPriceClass = 'ticket-system__popup-choose-sector-price-value-not-in-slider-bounds';
            }

            const decorateHTML = `
            <div class="ticket-system__popup-choose-sector-decorate" style="background-color: ${color}">
                <div class="ticket-system__popup-choose-sector-decorate-square" style="background-color: ${color}"></div>
            </div>
            `;

            let priceHTML = `
                <span class="ticket-system__popup-choose-sector-price-value ${minPriceClass}">от ${getRightSectorPrice(minPrice)} ₽</span>
                <span class="ticket-system__popup-choose-sector-price-value ${maxPriceClass}">до ${getRightSectorPrice(maxPrice)} ₽</span>
            `;

            if(WIDGET_DATA.availableDiscountTickets){
                priceHTML = `
                <span class="ticket-system__popup-choose-sector-price-value ${minPriceClass}">от ${getRightSectorPrice(minPrice/2)} ₽</span>
                <span class="ticket-system__popup-choose-sector-old-price ticket-system-double-price-variant">${getRightSectorPrice(minPrice)} ₽</span>
                <span class="ticket-system__popup-choose-sector-price-value ${maxPriceClass}">до ${getRightSectorPrice(maxPrice / 2)} ₽</span>
                <span class="ticket-system__popup-choose-sector-old-price">${getRightSectorPrice(maxPrice)} ₽</span>
            `;
            }

            if ((minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo) && (maxPrice < WIDGET_DATA.sliderFrom || maxPrice > WIDGET_DATA.sliderTo)) {
                buttonDisabledClass = 'ticket-system__button--disabled';
            }

            //в случае если какая-либо цена = 0 / отсутствует или они равны
            if (!minPrice || minPrice === 0) {
                priceHTML = `<span class="${maxPriceClass}">${getRightSectorPrice(maxPrice)} ₽</span>`;

                if(WIDGET_DATA.availableDiscountTickets){
                    priceHTML = `<span class="${maxPriceClass}">${getRightSectorPrice(maxPrice/2)} ₽</span><span class="ticket-system__popup-choose-sector-old-price">${getRightSectorPrice(maxPrice)} ₽</span>`;
                }

                //если мин цены нет/равна 0, а макс - не входит в границы слайдера -> делаем кнопку неактивной
                if (maxPrice < WIDGET_DATA.sliderFrom || maxPrice > WIDGET_DATA.sliderTo) {
                    buttonDisabledClass = 'ticket-system__button--disabled';
                }
            }

            if (!maxPrice || maxPrice === 0) {
                priceHTML = `<span class="${minPriceClass}">${getRightSectorPrice(minPrice)} ₽</span>`;

                if(WIDGET_DATA.availableDiscountTickets){
                    priceHTML = `<span class="${minPriceClass}">${getRightSectorPrice(minPrice/2)} ₽</span><span class="ticket-system__popup-choose-sector-old-price">${getRightSectorPrice(minPrice)} ₽</span>`;
                }

                //если макс цены нет/равна 0, а мин - не входит в границы слайдера -> делаем кнопку неактивной
                if (minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo) {
                    buttonDisabledClass = 'ticket-system__button--disabled';
                }
            }

            if (maxPrice === minPrice) {
                priceHTML = `<span class="${minPriceClass}">${getRightSectorPrice(minPrice)} ₽</span>`;

                if(WIDGET_DATA.availableDiscountTickets){
                    priceHTML = `<span class="${minPriceClass}">${getRightSectorPrice(minPrice/2)} ₽</span><span class="ticket-system__popup-choose-sector-old-price">${getRightSectorPrice(minPrice)} ₽</span>`;
                }

                //если макс цены нет/равна 0, а мин - не входит в границы слайдера -> делаем кнопку неактивной
                if (minPrice < WIDGET_DATA.sliderFrom || minPrice > WIDGET_DATA.sliderTo) {
                    buttonDisabledClass = 'ticket-system__button--disabled';
                }
            }

            const flagKostil = WIDGET_DATA.matchId === 3290 && name.toLowerCase() === 'b530';

            let sectorNameHTML = `
            ${
                flagKostil ?
                    `<span class="bone-sector-name">
                        <span class="ticket-system__hide-mobile"></span>
                        ${translator('СЕКТОР ЦСКА',WIDGET_DATA.lang)}, </span>`
                    : ''
            }
            ${
                flagKostil ?
                    `${translator('Сектор',WIDGET_DATA.lang).toLowerCase()}`
                    : `${translator('Сектор',WIDGET_DATA.lang)}`
            } 
            <span style="text-transform: uppercase">${name[0]}</span>,${translator('блок',WIDGET_DATA.lang)} <span style="color: ${color};text-transform: uppercase;">${name}</span>`;

            if(WIDGET_DATA.customVipSectors.includes(id)){
                sectorNameHTML = `VIP ${translator('сектор',WIDGET_DATA.lang)} <span style="text-transform: uppercase">${name[0]}</span>,${translator('блок',WIDGET_DATA.lang)} <span style="color: ${color};text-transform: uppercase;">${name.slice(1)}</span>`
            }

            if(WIDGET_DATA.customVipSectors.includes(id)){
                sectorNameHTML = `VIP ${translator('сектор',WIDGET_DATA.lang)} <span style="text-transform: uppercase">${name[0]}</span>,${translator('блок',WIDGET_DATA.lang)} <span style="color: ${color};text-transform: uppercase;">${name.slice(1)}</span>`
            }

            if (WIDGET_DATA.arenaId === '19') {
                sectorNameHTML = `Сектор <span style="text-transform: uppercase">${name}</span>`;

                // 3297, 12 сектор - ДИНАМО ГОСТЕВОЙ ( 48590 задача )
                if(WIDGET_DATA.matchId === 3297 && +id === 19846){
                    sectorNameHTML = `<style>@media (max-width: 1000px) {
                    .metallurg-dinamo-sector{display: block}
                    }</style>${translator('Сектор',WIDGET_DATA.lang)} <span class="metallurg-dinamo-sector">${translator('ДИНАМО ГОСТЕВОЙ',WIDGET_DATA.lang)}</span>`;
                }
            }

            let matchInfoHTML = `
            <div class="ticket-system__popup-choose-sector-info">
                <div class="ticket-system__popup-choose-sector-header">${sectorNameHTML}</div>
                <div class="ticket-system__popup-choose-sector-free-places">${freePlaces} ${placesFreeWord} ${translator('свободно',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__popup-choose-sector-hr"></div>
                <div class="ticket-system__popup-choose-sector-price">${priceHTML}</div>
            </div>
            `;

            if(WIDGET_DATA.customSectorAccess){
                buttonDisabledClass = '';
            }

            let buttonHTML = `
            <div class="ticket-system__button--darkCyan ${buttonDisabledClass} ticket-system__hide-desktop" data-ticket-system__choose-place-step>${translator('Продолжить',WIDGET_DATA.lang)}</div>
            `;

            let closeHTML = `
             <div class="ticket-system__popup-choose-close-block ticket-system__hide-desktop" data-close-choose-sector-popup>
                <div class="ticket-system__icon__close"></div>
             </div>
            `;

            //Если все продано убираем кнопку и цену
            if (+freePlaces === 0) {
                buttonHTML = ``;
                matchInfoHTML = `
                    <div class="ticket-system__popup-choose-sector-info">
                        <div class="ticket-system__popup-choose-sector-header">${sectorNameHTML}</div>
                        <div class="ticket-system__popup-choose-sector-free-places" style="margin-top: 30px;font-size: 18px;">${translator('Нет свободных мест', WIDGET_DATA.lang)}</div>
                    </div>
                `;
            }

            //если сектор отключен, то выводим сообщение о недоступности покупки билета в данном секторе
            if (isDisabled) {
                buttonHTML = ``;
                matchInfoHTML = `
                    <div class="ticket-system__popup-choose-sector-info">
                        <div class="ticket-system__popup-choose-sector-header">Сектор <span style="color: ${color};">${id}</span></div>
                        <div class="ticket-system__popup-choose-sector-free-places" style="margin-top: 30px;font-size: 18px;">${translator('Недоступен для продажи', WIDGET_DATA.lang)}</div>
                    </div>
                `;
            }

            const popupHTML = decorateHTML + matchInfoHTML + buttonHTML + closeHTML;
            $domElements.popupChooseSectorContent.html(popupHTML);

            function getRightSectorPrice(price) {
                //если число целое - возвращаем без разделителей
                if (Number.isInteger(price)) {
                    return number_format(price, '', '', ' ')

                    //иначе - с копейками
                } else {
                    return number_format(price, 2, ',', ' ')
                }
            }
        }

        function checkSectorInSliderPrice(sector) {
            const sectorMinPrice = +sector.data('minPrice');
            const sectorMaxPrice = +sector.data('maxPrice');

            return !(sectorMinPrice < WIDGET_DATA.sliderFrom && sectorMaxPrice < WIDGET_DATA.sliderFrom ||
                sectorMinPrice > WIDGET_DATA.sliderTo && sectorMaxPrice > WIDGET_DATA.sliderTo);
        }
    }

    function getPlaces() {
        showPreloader();

        let data = {
            /*  userId: WIDGET_DATA.userId,*/
            sectorId: WIDGET_DATA.chosenSector.id,
            matchId: WIDGET_DATA.matchId,
            arenaId: +WIDGET_DATA.arenaId
        };

        $.ajax({
            url: `${AJAX_URL}/ajax/getPlaces/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn(data.payload);

                } else {
                    errorHandler(data, 'places');
                }
            },
            error: function () {
                if (AJAX_MODE === 'dev') {
                    const data = mockups.placeSelectMockup

                    if (isDataCorrect(data)) {
                        successFn(data.payload);

                    } else {
                        errorHandler(data, 'places');
                    }

                } else {
                    errorHandler(data, 'places');
                }
            },
            timeout: 30000
        });

        function successFn(data) {
            WIDGET_DATA.placesRenderSettings = data?.settings;
            WIDGET_DATA.places = data?.places;

            //прверяем есть ли забронированные места с других матчей
            if(AJAX_MODE !== 'dev'){
                checkWrongReserveSeats();
            }

            //для билетов проверяем куку
            checkPlacesCookie();
            filterPlacesPrice(WIDGET_DATA);

            //если есть забронированные места - отключаем прелоадер после инициализации таймера
            initDeadlineTimer();

            if(!WIDGET_DATA.userInfo.seatInReserve.length){
                hidePreloader();
            }

            WIDGET_DATA.isPlacesPageInited = 1;

            function checkPlacesCookie() {
                // если есть уже забронированные места в данных при инициализации виджета и кука deadline
                if (WIDGET_DATA.userInfo.seatInReserve.length !== 0 && getCookie('deadline')) {
                    let reservedTickets = [];

                    WIDGET_DATA.userInfo.seatInReserve.forEach(reservedPlace => {
                        if(+WIDGET_DATA.chosenSector?.id !== +reservedPlace.sector){
                            return;
                        }

                        const reserveTicket = WIDGET_DATA.places.find(placeFromServer => {
                            if (placeFromServer.id === reservedPlace.seat) {
                                return placeFromServer;
                            }
                        });

                        //цену, категорию и зону берём из данных,
                        // что пришли на ините виджета (резервированные места) - остальное есть в данных всех мест
                        //поле discount - с reservedSeats
                        reservedTickets.push(
                            {
                                id: reserveTicket.id,
                                placeNumber: reserveTicket.seat,
                                rowNumber: reserveTicket.row,
                                fanId: reservedPlace?.fanId,
                                price: reservedPlace.price,
                                categoryId: reservedPlace.categoryId,
                                zoneId: reservedPlace.zoneId,
                                isTicketWithSale: reservedPlace.isTicketWithSale,
                                discount: reservedPlace.discount,
                                type: 'ticket'
                            }
                        )
                    });

                    WIDGET_DATA.chosenTickets = reservedTickets;

                    if(!reservedTickets.length){
                        renderPlaces(WIDGET_DATA, $domElements, false);
                        initChoosePlaceHandlers();
                        $(window).on('resize', () => {
                            initChoosePlaceHandlers();
                        });

                    }else{
                        renderPlaces(WIDGET_DATA, $domElements, true);
                        initChoosePlaceHandlers();
                        $(window).on('resize', () => {
                            initChoosePlaceHandlers();
                        });
                    }

                    //переход на Подтверждение заказа отслеживается в переходе на Ваш заказ
                    route('choose_place');
                    WIDGET_DATA.isPlacesPageInited = 1;

                } else {
                    renderPlaces(WIDGET_DATA, $domElements, false);
                    initChoosePlaceHandlers();
                    $(window).on('resize', () => {
                        initChoosePlaceHandlers();
                    });
                }
            }

            function checkWrongReserveSeats(){
                let wrongReserveSeats = {};

                WIDGET_DATA.userInfo.seatInReserve = WIDGET_DATA.userInfo.seatInReserve.filter( function(reserveSeat) {
                    if(+reserveSeat.matchId === +WIDGET_DATA.matchId){
                        return reserveSeat;
                    }else{
                        if(!wrongReserveSeats.hasOwnProperty(reserveSeat.matchId)){
                            wrongReserveSeats[`${reserveSeat.matchId}`] = [];
                        }

                        wrongReserveSeats[`${reserveSeat.matchId}`].push(reserveSeat);
                    }
                });

                if (Object.keys(wrongReserveSeats).length !== 0) {
                    for (let matchId in wrongReserveSeats) {
                        deleteBooking(wrongReserveSeats[matchId], matchId);
                    }
                }
            }
        }
    }

    function initChoosePlaceHandlers() {
        WIDGET_DATA.placesDOMElements.forEach((item) => {
            const $item = $(item);

            $item.off('click');
            $item.off('mouseenter');
            $item.off('mouseleave');

            if (isDesktop()) {
                $item
                    .on('mouseenter', () => {
                        handlerMouseenter($item);
                    })
                    .on('mouseleave', () => {
                        handlerMouseleave($item);
                    })
                    .on('click', () => {
                        handlerClick($item);
                    });

            } else {
                $item.on('click', () => {
                    handlerClick($item);
                    return false;
                });

                //закрытие popup
                /* $domElements.body.on('click', '[data-close-choose-place-popup]', () => {
                     handlerMouseleave($item);
                     return false;
                });*/
            }
        })

        initTicketsPopupHandler();

        //открытие фильтра
        $domElements.body.on('click', '#ticket_system_filter', () => {
            //если попап был открыт - сворачиваем
            if (WIDGET_DATA.chosenTickets.length !== 0) {
                $domElements.popupTickets.removeClass('ticket-system__popup-tickets-active');
                $domElements.popupTickets.removeClass('ticket-system__popup-tickets-rolled');

                setTimeout(() => {
                    showFilterPopup($domElements.popupFilter);
                }, 200)
                return false;
            }
            showFilterPopup($domElements.popupFilter);
            return false;
        });

        //закрытие фильтра
        $domElements.body.on('click', '.ticket-system__popup-filter-close-block', () => {
            if (WIDGET_DATA.chosenTickets.length !== 0) {

                hideFilterPopup($domElements.popupFilter);
                setTimeout(() => {
                    $domElements.popupTickets.addClass('ticket-system__popup-tickets-active');
                }, 200)
                return false;
            }
            hideFilterPopup($domElements.popupFilter)
            return false;
        });

        //следующий шаг
        $domElements.body.on('click', '[data-ticket__next-step]', () => {
            WIDGET_DATA.previousPage = 'choose_place';
            WIDGET_DATA.currentPage = 'order_info';
            route('order_info');
            setCookie('chosen_tickets_current_page', 'order_info');
        });

        function initTicketsPopupHandler() {
            $domElements.body.off('click', '.ticket-system__popup-ticket-right');
            $domElements.body.on('click', '.ticket-system__popup-ticket-right', e => {
                const $clickedTicket = $(e.currentTarget).parents('.ticket-system__popup-ticket');
                const ticketId = $clickedTicket.data('ticket__slide-id');

                WIDGET_DATA.chosenTickets = WIDGET_DATA.chosenTickets.filter(item => item.id !== ticketId);
                /*WIDGET_DATA.order = WIDGET_DATA.order.filter(item => {
                    if (item.type === 'ticket' && item.id === ticketId) {
                        return
                    }

                    return item;
                });*/
                removeTicketFromChosen(ticketId);
                //сейчас пользователь на Выборе места
                setCookie('chosen_tickets_current_page', 'choose_place');

                renderTicketsPopup($domElements, WIDGET_DATA);
            })
        }


        function showPopupChoosePlace() {
            $domElements.popupChoosePlace.addClass('ticket-system__popup-show');
            setTimeout(() => {
                $domElements.popupChoosePlace.addClass('ticket-system__popup-show-effect');
            }, 5);
        }

        function handlerMouseenter(item) {
            const placeState = item.data('ticket__state');
            const isChosenPlace = +item.data('ticket__is-chosen-place') === 1;
            const isTicketInPriceBounds = +item.data('ticket__is-in-price-bounds') === 1;

            if (+placeState !== 0 && !isChosenPlace && isTicketInPriceBounds) {
                item.css('transform', 'scale(1.5)');
                item.append(`<div class="ticket-system__choose-places-hover-icon"></div>`);

                setDataPopupChoosePlace(item);
                showPopupChoosePlace();
            }
        }

        function handlerMouseleave(item) {
            const placeState = item.data('ticket__state');
            const isChosenPlace = +item.data('ticket__is-chosen-place') === 1;

            if (+placeState !== 0 && !isChosenPlace) {
                item.css('transform', 'scale(1)');
                item.empty();
                hidePopupChoosePlace($domElements.popupChoosePlace, $domElements.popupChoosePlaceContent);
            }
        }

        function handlerClick(item) {
            const id = item.data('ticket__place-id');
            const isPlaceChosen = item.data('ticket__is-chosen-place');
            const placeState = item.data('ticket__state');
            const isPlaceInSliderBounds = +item.data('ticket__is-in-price-bounds') === 1;

            if (+isPlaceChosen === 0 && +placeState !== 0 && isPlaceInSliderBounds) {
                //абонемент - лимит из объекта abonement на getWidgetData
                if (WIDGET_DATA.isAbonement) {
                    if (WIDGET_DATA.chosenTickets.length === WIDGET_DATA.abonementData.limit) {
                        showWarningChoosePlaceModal();
                        return;

                    } else {

                        //костыль для 3 матчей 3237, 3238, 3239 - без fan id
                        if(!WIDGET_DATA.fanIdRequired){
                            setCurrentChosenTicket(item);
                            reserveTicketWithoutFanId(item);

                        }else{
                            showFanIdModal(item);
                        }
                        /*addTicketToChosen(item);*/
                    }

                    //билеты
                    //если пытаемся выбрать 21 билет -> показываем модалку-предупреждение - больше 20 билетов на 1 человека купить нельзя
                } else {
                    if (WIDGET_DATA.chosenTickets.length === 20 || WIDGET_DATA.chosenTickets.length + 1  > 20 - WIDGET_DATA.maxCountTickets) {
                        showWarningChoosePlaceModal();
                        return;

                    } else {
                        if(!WIDGET_DATA.fanIdRequired){
                            setCurrentChosenTicket(item);
                            reserveTicketWithoutFanId(item);

                        }else{
                            showFanIdModal(item);
                        }
                        /*addTicketToChosen(item);*/
                    }
                }

            } else if (+placeState !== 0 && isPlaceInSliderBounds) {
                removeTicketFromChosen(id);
                //сейчас пользователь на Выборе места
                setCookie('chosen_tickets_current_page', 'choose_place');

                //ререндер попапа выбранных мест
                renderTicketsPopup($domElements, WIDGET_DATA);
            }

            function showWarningChoosePlaceModal() {
                if (WIDGET_DATA.isAbonement) {
                    $('[data-ticket-system__choose-place-warning-modal-text]')
                        .text(`${translator('К продаже доступно максимум ', WIDGET_DATA.lang)}
                        ${WIDGET_DATA.abonementData.limit}
                        ${getRightTerm(
                            WIDGET_DATA.abonementData.limit,
                            translator('абонемент', WIDGET_DATA.lang),
                            translator('абонемента', WIDGET_DATA.lang),
                            translator('абонементов', WIDGET_DATA.lang))}
                        ${translator(' для одного пользователя', WIDGET_DATA.lang)}`);

                } else {
                    $('[data-ticket-system__choose-place-warning-modal-text]')
                        .text(`${translator('На данное мероприятие нет возможности приобрести больше 20‑ти билетов', WIDGET_DATA.lang)}`);
                }


                $domElements.body.css('overflow', 'hidden');
                $domElements.modalChoosePlaceWarning.addClass('active');
                setTimeout(() => {
                    $domElements.modalChoosePlaceWarning.addClass('active-effect');
                }, 50);
            }
        }

        function showFilterPopup() {
            $domElements.popupFilter.addClass('ticket-system__popup-filter-show');
            setTimeout(() => {
                $domElements.popupFilter.addClass('ticket-system__popup-filter-show-effect');
            }, 5);
        }

        function hideFilterPopup() {
            $domElements.popupFilter.removeClass('ticket-system__popup-filter-show-effect');
            setTimeout(() => {
                $domElements.popupFilter.removeClass('ticket-system__popup-filter-show');
            }, 400);
        }

        function setDataPopupChoosePlace(item) {
            const color = WIDGET_DATA.chosenSector.color;
            const rowNumber = item.data('ticket__row-number');
            const price = +item.data('ticket__prices');
            const placeNumber = item.data('ticket__place-number');

            let descriptionText = `${translator('цена билета',WIDGET_DATA.lang)}`;

            if (WIDGET_DATA.isAbonement) {
                descriptionText = '';
            }

            const decorateHTML = `
            <div class="ticket-system__popup-choose-sector-decorate" style="background-color: ${color}">
                <div class="ticket-system__popup-choose-sector-decorate-square" style="background-color: ${color}"></div>
            </div>
            `;

            let priceHTML =  `<div class="ticket-system__popup-choose-sector-price">${getRightPlacePrice(price)} ₽ <span class="ticket-system__popup-choose-sector-price-text">${descriptionText}</span></div>`;

            if(WIDGET_DATA.chosenTickets.length < WIDGET_DATA.availableDiscountTickets){
                priceHTML =  `<div class="ticket-system__popup-choose-sector-price"> ${getRightPlacePrice(price/2)} ₽
                    <span class="ticket-system__popup-choose-sector-old-price ticket-system__no-margin-left">${getRightPlacePrice(price)} ₽</span>
                    <span class="ticket-system__popup-choose-sector-price-text">${descriptionText}</span>
                </div>`;
            }


            let matchInfoHTML = `
            <div class="ticket-system__popup-choose-sector-info">
                <div class="ticket-system__popup-choose-sector-header">${translator('Ряд',WIDGET_DATA.lang)} ${rowNumber}, ${translator('место',WIDGET_DATA.lang)} ${placeNumber}</div>
                <div class="ticket-system__popup-choose-sector-hr"></div>
                ${priceHTML}
            </div>
        `;

            let buttonHTML = `
            <div class="ticket-system__button--darkCyan ticket-system__hide-desktop" data-ticket-system__choose-place-step>${translator('Продолжить',WIDGET_DATA.lang)}Продолжить</div>
        `;

            let closeHTML = `
             <div class="ticket-system__popup-choose-close-block ticket-system__hide-desktop" data-close-choose-sector-popup>
                <div class="ticket-system__icon__close"></div>
             </div>
        `

            const popupHTML = decorateHTML + matchInfoHTML + buttonHTML + closeHTML;
            $domElements.popupChoosePlaceContent.html(popupHTML);

            function getRightPlacePrice(price) {
                //если число целое - возвращаем без разделителей
                if (Number.isInteger(price)) {
                    return number_format(price, '', '', ' ')

                    //иначе - с копейками
                } else {
                    return number_format(price, 2, ',', ' ')
                }
            }
        }

        function showFanIdModal(item){
            setCurrentChosenTicket(item);

            $domElements.body.css('overflow', 'hidden');
            $domElements.modalSendFanId.addClass('active');
            setTimeout(() => {
                $domElements.modalSendFanId.addClass('active-effect');
            }, 50);
        }

        function setCurrentChosenTicket(item){
            const rowNumber = item.data('ticket__row-number');
            const price = item.data('ticket__prices');
            const id = item.data('ticket__place-id');
            const categoryId = item.data('ticket__category-id');
            const zoneId = item.data('ticket__zone-id');
            const placeNumber = item.data('ticket__place-number');

            const chosenPlace = {
                id,
                placeNumber,
                rowNumber,
                price,
                categoryId,
                zoneId,
                type: 'ticket'
            };

            Object.assign(WIDGET_DATA.currentChosenTicket,chosenPlace);
        }

        function removeTicketFromChosen(ticketId) {
            deleteBooking(ticketId);
        }
    }

    function addTicketToChosen(item, fanId) {
        const $item = $(`.ticket-system__choose-places-item[data-ticket__place-id=${item.id}]`);

        const rowNumber = $item.data('ticket__row-number');
        const price = $item.data('ticket__prices');
        const id = $item.data('ticket__place-id');
        const categoryId = $item.data('ticket__category-id');
        const zoneId = $item.data('ticket__zone-id');
        const placeNumber = $item.data('ticket__place-number');
        let isTicketWithSale = false;

        $item.addClass('ticket-system__choose-places-chosen-place');
        $item.html('');
        $item.text(placeNumber);
        $item.data('ticket__is-chosen-place', '1');
        hidePopupChoosePlace($domElements.popupChoosePlace, $domElements.popupChoosePlaceContent);
        $domElements.popupTickets.addClass('ticket-system__popup-tickets-active');

        //если количество доступных для покупки билетов
        // со скидкой > 0 - прокидываем в билет флаг, что он со скидкой и уменьшаем количество на 1
        if(WIDGET_DATA.chosenTickets.length <= WIDGET_DATA.availableDiscountTickets){
            isTicketWithSale = true;
        }

        const chosenPlace = {
            id: `${id}`,
            placeNumber: `${placeNumber}`,
            rowNumber: `${rowNumber}`,
            price: `${price}`,
            categoryId: `${categoryId}`,
            zoneId: `${zoneId}`,
            fanId,
            isTicketWithSale,
            type: 'ticket'
        };

        WIDGET_DATA.userInfo.seatInReserve.push({
            seat: `${id}`,
            price: `${price}`,
            category: `${categoryId}`,
            zone: `${zoneId}`,
            sector: `${WIDGET_DATA.chosenSector.id}`
        });

        WIDGET_DATA.chosenTickets.push(chosenPlace);
        //сейчас пользователь на Выборе места
        setCookie('chosen_tickets_current_page', 'choose_place');

        //ререндер попапа выбранных мест
        renderTicketsPopup($domElements, WIDGET_DATA);
    }

    function reserveTicketWithoutFanId(item){
        showPreloader();

        const ajaxData = {
            matchId: WIDGET_DATA.matchId,
            fanId: '',
            chosenPlaces: [
                {
                    seatId: +WIDGET_DATA.currentChosenTicket.id,
                    zoneId: +WIDGET_DATA.currentChosenTicket.zoneId,
                    categoryId: +WIDGET_DATA.currentChosenTicket.categoryId
                }
            ]
        };

        $.ajax({
            url: `${AJAX_URL}/ajax/createBooking/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(ajaxData),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn(ajaxData.fanId);

                } else {
                    errorFn(data);
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.fanId;
                    if (isDataCorrect(data) && data?.payload?.ResultCode !== '20115') {
                        successFn(ajaxData.fanId);

                    } else {
                        errorFn(data);
                    }
                } else {
                    errorFn(data);
                }
            },
            timeout: 30000
        });

        function successFn(fanId){
            addTicketToChosen(WIDGET_DATA.currentChosenTicket, '');
            //записываем в куку время бронирования
            const dateWithTimeZone = new Date();
            dateWithTimeZone.setHours(dateWithTimeZone.getHours() - new Date().getTimezoneOffset() / 60);
            dateWithTimeZone.setMinutes(dateWithTimeZone.getMinutes() + 30);
            setCookie('deadline', dateWithTimeZone);
            initDeadlineTimer('extend');
            hidePreloader();
        }

        function errorFn(data){
            //ошибка бронирования - уже зарезервированно
            errorHandler(data,'booking');
            hidePreloader();
        }
    }

    /*function getServicesData() {
        showPreloader();
        let data = {};

        $.ajax({
            url: '/ajax/getServices/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (data) {
                successFn(data);
            },
            error: function () {
                if (AJAX_MODE === 'dev') {
                    const data = mockups.orderInfo;
                    successFn(data);
                }
                errorFn();
            },
            timeout: 30000
        });

        function successFn(data) {
            if(!data || isEmpty(data)){
                errorFn();
                return;
            }

            WIDGET_DATA.serviceProducts = data?.serviceProducts;
           /!* WIDGET_DATA.order = WIDGET_DATA.chosenTickets;*!/
            WIDGET_DATA.isOrderInfoPageInited = 1;
            renderTicketsInfo(WIDGET_DATA);
            renderServices(WIDGET_DATA);
            initOrderInfoHandlers();
            hidePreloader();
        }

        function errorFn() {
            hidePreloader();
            //ошибочный экран
        }
    }*/

    function initOrderInfoHandlers() {
        //клик по "Добавить" в доп услугах, но сначала отключаем клик (в случае перехода с Подтверждения заказа обратно)
        $domElements.body.off('click', '.ticket-system__order-service-item-button:not(.parking)');
        $domElements.body.on('click', '.ticket-system__order-service-item-button:not(.parking)', e => {
            const $currentService = $(e.currentTarget);
            const $parent = $currentService.parents('.ticket-system__order-service-item');

            const servicePrice = $currentService.data('ticket-service-price');
            const serviceId = $currentService.data('ticket-service-id');

            const clickedServiceData = {
                id: serviceId,
                price: servicePrice
            }

            WIDGET_DATA.chosenServices.push(clickedServiceData);
            $parent.addClass('chosen');

            calculateFullPrice(WIDGET_DATA);
        })

        //удаление тикета/услуги из "Ваш заказ", но сначала отключаем клик (в случае перехода с Подтверждения заказа обратно)
        $domElements.body.off('click', '.ticket-system__order-info-ticket-delete');
        $domElements.body.on('click', '.ticket-system__order-info-ticket-delete', e => {
            const $clickedOrderItem = $(e.currentTarget);

            /*if (orderItemType === 'ticket') {
                removeTicketFromChosen($clickedOrderItem);

            } else {
                removeServiceFromChosen($clickedOrderItem);
            }*/
            removeTicketFromChosen($clickedOrderItem);

            if(WIDGET_DATA.chosenTickets.length > 0){
                getPoints();
            }

            calculateFullPrice(WIDGET_DATA);
        });

        //удаление услуги
        /*$domElements.body.off('click', '.ticket-system__order-info-service-right');
        $domElements.body.on('click', '.ticket-system__order-info-service-right', e => {
            const $clickedOrderItem = $(e.currentTarget);
            removeServiceFromChosen($clickedOrderItem);
            calculateFullPrice(WIDGET_DATA);
        })*/

        //переход на шаг "Подтверждение заказа"
        $domElements.body.on('click', '[data-ticket_system-submit-order-step]', () => {
            //проверяем - есть ли билеты в заказе
            const isTicketsInOrder = WIDGET_DATA.chosenTickets.filter(orderItem => {
                return orderItem.type === 'ticket'
            }).length !== 0;

            if (isTicketsInOrder) {
                showPreloader();
                WIDGET_DATA.previousPage = 'order_info';
                route('submit_order');

            } else {
                //предупреждение о невыбранных билетах
                alert('вы не выбрали билеты');
            }

        });

        //переход на Выбор сектора при клике на кнопку в блоке, когда пользователь удалил все билеты
        $domElements.body.on('click', '[data-ticket_system-order-info-no-tickets-button]', () => {
            route('choose_place');

            //убираем сообщение и активируем кнопку перехода на Подтверждении заказа
            setTimeout(() => {
                $domElements.orderInfoNoTicketsMessage.addClass('ticket-system__hide');
                $domElements.orderInfoNextStepButton.removeClass('ticket-system__button--disabled');
            }, 50);
        });

        //открытие модалки с паркингом
        /*$domElements.body.on('click', '.ticket-system__order-service-item-button.parking', () => {
            $domElements.body.css('overflow', 'hidden');
            $('#ticket_system__choose-parking').addClass('active');
            setTimeout(() => {
                $('#ticket_system__choose-parking').addClass('active-effect');
            }, 50);
        });*/

        //закртыие модалки с паркингом
        /*$domElements.body.on('click', '.ticket-system__close-parking-modal', () => {
            $domElements.body.css('overflow', 'auto');
            $('#ticket_system__choose-parking').removeClass('active-effect');
            setTimeout(() => {
                $('#ticket_system__choose-parking').removeClass('active');
            }, 50);
        });*/

        //выбор паркинга
        /*$domElements.body.on('click', '.ticket-system__order-parking-item-button:not(.clicked)', e => {
            const $clickedParking = $(e.currentTarget);
            const $allParkingButtons = $('[data-ticket_system-modal-parking-wrapper]').find('.ticket-system__order-parking-item-button');

            if (!$clickedParking.hasClass('clicked')) {
                $allParkingButtons.each((_, parkingBtn) => {
                    $(parkingBtn).removeClass('clicked');
                });

                $clickedParking.addClass('clicked');
            }
        });*/

        //применение паркинга
        /*$domElements.body.on('click', '[data-submit-parking-modal]', () => {
            const $activeParking = $('[data-ticket_system-modal-parking-wrapper]').find('.ticket-system__order-parking-item-button.clicked');

            if ($activeParking.length) {
                const parkingId = $activeParking.data('ticket-service-id');
                const parkingPrice = $activeParking.data('ticket-service-price');

                $('#ticket_system__choose-parking').removeClass('active-effect');
                setTimeout(() => {
                    $('#ticket_system__choose-parking').removeClass('active');
                }, 50);
                $domElements.body.css('overflow', 'auto');

                WIDGET_DATA.chosenParkings.push(
                    {
                        id: parkingId,
                        price: parkingPrice
                    }
                );

                renderParking(WIDGET_DATA);
            }
        });*/

        //удаление паркинга
        /*$domElements.body.on('click', '.ticket-system__order-info-chosen-parking-delete', e => {
            const $deleteParkingBtn = $(e.currentTarget);
            const chosenParkingId = $deleteParkingBtn.data('ticket-service-id');

            WIDGET_DATA.chosenParkings = WIDGET_DATA.chosenParkings.filter(chosenParking => {
                return chosenParking.id !== chosenParkingId;
            });

            renderParking(WIDGET_DATA);
        });*/


        //сворачивание/разворачивание секции
        $domElements.body.off('click', '[data-ticket-system__rolling-trigger]');
        $domElements.body.on('click', '[data-ticket-system__rolling-trigger]', function () {
            const rollType = $(this).data('ticket-system__rolling-trigger');

            $(this).toggleClass('rolled');
            $(`[data-ticket-system__rolling-content="${rollType}"]`).toggleClass('rolled');
        });

        function removeTicketFromChosen(ticket) {
            const ticketId = ticket.parents('.ticket-system__order-info-ticket-main-info').data('ticket-system-order-info-ticket-remove-id');

            deleteBooking(ticketId);

            WIDGET_DATA.chosenTickets = WIDGET_DATA.chosenTickets.filter(orderItem => {
                if (orderItem.type === 'service') {
                    return orderItem;
                }
                return orderItem.id !== ticketId;
            });

            //убираем выбранное места с рендера на "Выбор места"
            WIDGET_DATA.chosenTickets = WIDGET_DATA.chosenTickets.filter(ticket => {
                return +ticket.id !== ticketId;
            });

            const $removedTicket = $(`.ticket-system__choose-places-item[data-ticket__place-id="${ticketId}"]`);

            $removedTicket.removeClass('ticket-system__choose-places-chosen-place');
            $removedTicket.empty();
            $removedTicket.data('ticket__is-chosen-place', 0);
            $removedTicket.data('ticket__is-clicked-place', 0);
            $removedTicket.css('transform', 'scale(1)');

            //если удалены все выбранные билеты -> показываем сообщение и блокируем кнопку, скрываем поле с общей стоимостью
            if (WIDGET_DATA.chosenTickets.length === 0) {
                $domElements.orderInfoNoTicketsMessage.removeClass('ticket-system__hide');
                $domElements.orderInfoNextStepButton.addClass('ticket-system__button--disabled');
                $('.ticket-system__order-info-block-prices').addClass('ticket-system__hide');

            }

            renderTicketsInfo(WIDGET_DATA);
        }

        /*function removeServiceFromChosen(service) {
            const $serviceTicket = service.parents('.ticket-system__order-service-item');
            const serviceId = $serviceTicket.data('service-id');

            WIDGET_DATA.chosenServices = WIDGET_DATA.chosenServices.filter(serviceItem => {
                return serviceItem.id !== serviceId;
            });

            $serviceTicket.removeClass('chosen');
            calculateFullPrice(WIDGET_DATA);
        }*/
    }

    function initSubmitOrderHandlers() {
        const regexRU = /[^а-яА-Я]/g;
        const regexENG = /[^a-zA-Z]/g;
        const phoneRegex = /[^0-9\-\+\(\)\ ]/g;
        const validFirstPhoneNumbers = ['7', '8', '9', '+'];
        let lastSymbol = 0;

        $('#phone_or_email_input').keydown(function (e) {
            lastSymbol = e.which;

            if (e.which === 8 && $(this).val()[$(this).val().length - 1] === '-') {
                $(this).val($(this).val().substring(0, $(this).val().length))
            }

            if (WIDGET_DATA.currentPhoneOrEmailMask === 'phone' && typeof +$(this).val()[$(this).val().length - 1] !== 'number') {
                $(this).val($(this).val().substring(0, $(this).val().length))
            }
        })

        //валидация почты/телефона на вводе
        $('#phone_or_email_input').on('input', function () {
            if (WIDGET_DATA.currentPhoneOrEmailMask === 'phone') {
                $(this).val($(this).val().replace(phoneRegex, ''));

            }

            if ($(this).val().length === 0) {
                WIDGET_DATA.currentPhoneOrEmailMask = 'email';
            }
            //отказ от телефона

            //меняем маску на телефон, если вводим подходящие символы
            /* if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length === 1) {
                 if ($(this).val()[0] === '+') {
                     $(this).val(`+7 (`);

                 } else {
                     $(this).val(`+7 (${$(this).val()[0]}`);
                 }

                 WIDGET_DATA.currentPhoneOrEmailMask = 'phone';
             }

             //если удаляем символ и в инпуте осталось только '+7 ('
             if ($(this).val() === '+7 ') {
                 $(this).val('');
                 WIDGET_DATA.currentPhoneOrEmailMask = 'email';
             }

             //закрываем скобку после кода региона и ставим пробел
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length === 7 && lastSymbol !== 8) {
                 $(this).val(`${$(this).val()}) `);
             }

             //ставим первый '-'
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length === 12 && lastSymbol !== 8) {
                 $(this).val(`${$(this).val()}-`);
             }

             //если на 13 месте не '-' -> ставим его
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val()[12] && $(this).val()[12] !== '-') {
                 $(this).val(`${$(this).val()}-`);
             }

             //ставим второй '-'
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length === 15 && lastSymbol !== 8) {
                 $(this).val(`${$(this).val()}-`);
             }

             //если на 16 месте не '-' -> ставим его
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length === 12 && lastSymbol !== 8) {
                 $(this).val(`${$(this).val()}-`);
             }

             //если мы ввели номер телефона -> отключаем возможность написать более 18 символов
             if (validFirstPhoneNumbers.includes($(this).val()[0]) && $(this).val().length > 18) {
                 $(this).val($(this).val().slice(0, 18));
             }*/
        });

        //валидация имени/фамилии при уходе с инпута
        $('#phone_or_email_input').on('blur', function () {
            if ($(this).val() === '') {
                return;
            }

            validateDualInput('#phone_or_email_input', WIDGET_DATA.currentPhoneOrEmailMask);
        });


        //валидация имени и фамилии в зависимости от языка
        if(WIDGET_DATA.lang === 'en'){
            $('#first_name_input, #last_name_input').on('input', function () {
                $(this).val($(this).val().replace(regexENG, ''));
            });

        }else if(WIDGET_DATA.lang === 'ru'){
            $('#first_name_input, #last_name_input').on('input', function () {
                $(this).val($(this).val().replace(regexRU, ''));
            });
        }

        //валидируем форму при клике на кнопку. Если валидна - сабмитим
        $domElements.body.on('click', '[data-ticket-system-submit-order-submit-form]', () => {
            if (validateForm($domElements.submitOrderForm, true, WIDGET_DATA.currentPhoneOrEmailMask)) {
                if (WIDGET_DATA.userInfo.phone_or_email === '') {
                    sendPassword();
                } else {
                   getUserProfile();
                }
                return false;
            }
        });
    }

    //отмена брони
    function deleteBooking(ticketId, matchIdFromWrongPlaces = '',isReturnToChooseSector = false, isNeedToHidePreloader = true) {
        showPreloader();
        let chosenPlaces = [];

        //если массив - добавляем на удаление брони все места, что передаём
        if(Array.isArray(ticketId)){
            ticketId.forEach(ticketIdItem => {
                chosenPlaces.push({
                    seatId: +ticketIdItem.seat
                });
            });

        }else{
            chosenPlaces.push({
                seatId: +ticketId
            });
        }

        //для бека добавляем флаг для проверки оставшихся мест при переходе на выбор сектора
        //isReturnToChooseSector
        //(баг с 2 вкладками)

        const deleteBookingdata = {
            matchId: WIDGET_DATA.matchId,
            chosenPlaces: chosenPlaces,
            isReturnToChooseSector: isReturnToChooseSector
        };

        //если пришёл matchId - ставим (неправильные места)
        if(matchIdFromWrongPlaces !== ''){
            deleteBookingdata.matchId = +matchIdFromWrongPlaces;
        }

        deleteBookingdata.chosenPlaces = chosenPlaces;

        $.ajax({
            url: `${AJAX_URL}/ajax/deleteBooking/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(deleteBookingdata),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn(data);

                } else {
                    errorHandler(data);
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {

                    data = mockups.deleteBooking;

                    if (isDataCorrect(data)) {
                        successFn(data);

                    }else{
                        errorHandler(data);
                    }

                } else {
                    errorHandler(data);
                }
            },
            timeout: 30000
        });

        function successFn(data) {
            const $placeOnRender = $(`[data-ticket__place-id="${ticketId}"]`);

            $placeOnRender.removeClass('ticket-system__choose-places-chosen-place');
            $placeOnRender.html('');
            $placeOnRender.data('ticket__is-chosen-place', '0');
            $placeOnRender.css('transform', 'scale(1)');

            //проверяем - надо ли перебронировать след билет без скидки, если удаляем билет со скидкой
            handleDeleteBookingWithSale(ticketId);

            WIDGET_DATA.chosenTickets = WIDGET_DATA.chosenTickets.filter(item => +item.id !== ticketId);

            if(WIDGET_DATA.userInfo.seatInReserve.length){
                WIDGET_DATA.userInfo.seatInReserve =  WIDGET_DATA.userInfo.seatInReserve.filter(item => +item.seat !== ticketId);
            }
            renderTicketsPopup($domElements, WIDGET_DATA);

            //если массив, значит идёт переход на выбор сектора (удаляются все брони) - останавливаем таймер и скрываем его
            //если выбранных билетов 0 - обнуляем и останавливаем таймер
            if(Array.isArray(ticketId) || !WIDGET_DATA.chosenTickets.length) {
                clearInterval(WIDGET_DATA.deadlineTimerInstance);
                setCookie('deadline', false);
                WIDGET_DATA.deadlineTimerInstance = 0;
            }

            if(!WIDGET_DATA.chosenTickets.length){
                $domElements.deadlineTimer.addClass('ticket-system__hide');
            }

            if(isNeedToHidePreloader){
                hidePreloader();
            }

            //проверяем наличие доп. зарезервированных мест (2 вкладки, забронированно 4 места : по 2 на каждой.
            // Уходим с одной, бронь удаляется только с 1 вкладки, в ответе на deleteBooking ждём все тек зарезерв.
            // места для пользователя, чтобы удалить оставшиеся)
            if(data?.payload?.seatInReserve && data?.payload?.seatInReserve?.length && isReturnToChooseSector){
                deleteBooking(data?.payload?.seatInReserve);
            }
        }

        function handleDeleteBookingWithSale(ticketId){
            //если не массив (то есть, это не переход на выбор сектора с последующим удалением всей брони,
            // а просто удаление брони пользователем) -> проверяем статус билета (скидочный или нет),
            // удаляем бронь на след билет без скидки и заново бронируем
            // как скидочный (да-да, ебатория инфотеховская)

            if(Array.isArray(ticketId)) return;

            //пока не обновилось в данных, смотрим по верстке - удаляем ли мы место со скидкой
            const isDeletedSeatWithDiscount = $(`[data-ticket__slide-id='${ticketId}']`).find('.ticket-system__popup-choose-sector-old-price').length > 0;
            const nextTicketIdWithoutSale = $('[data-ticket__with-discount="false"]').data('ticket__slide-id');

            //если условие выполняется - удаляем бронь на след билет без скидки и бронируем его как скидочный
            if(isDeletedSeatWithDiscount && nextTicketIdWithoutSale){
                const perebronironieData = {
                    matchId: WIDGET_DATA.matchId,
                    chosenPlaces: [
                        {
                            seatId: nextTicketIdWithoutSale
                        }
                    ]
                }

                $.ajax({
                    url: `${AJAX_URL}/ajax/deleteBooking/`,
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(perebronironieData),
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        if (isDataCorrect(data)) {
                            successPerebronirovanieDelete(nextTicketIdWithoutSale);

                        } else {
                            errorHandler(data);
                        }
                    },
                    error: function () {
                        if (AJAX_MODE === 'dev') {
                            successPerebronirovanieDelete(nextTicketIdWithoutSale);

                        } else {
                            errorHandler(data);
                        }
                    },
                    timeout: 30000
                });

                function successPerebronirovanieDelete(nextTicketIdWithoutSale){
                    $domElements.modalSendFanId.removeClass('error');
                    $domElements.modalSendFanId.addClass('loading');

                    const nextTicketTicketData = WIDGET_DATA.chosenTickets.filter(item => +item.id === nextTicketIdWithoutSale)[0];

                    const ajaxData = {
                        matchId: WIDGET_DATA.matchId,
                        fanId: WIDGET_DATA.lastEnteredFanId,
                        chosenPlaces: [
                            {
                                seatId: +nextTicketTicketData.id,
                                zoneId: +nextTicketTicketData.zoneId,
                                categoryId: +nextTicketTicketData.categoryId,
                                discount: true
                            }
                        ]
                    };

                    $.ajax({
                        url: `${AJAX_URL}/ajax/createBooking/`,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(ajaxData),
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (data) {
                            if (isDataCorrect(data) && data?.payload?.ResultCode !== '20115') {
                                successFn(ajaxData.fanId);

                            } else {
                                errorFn(data);
                            }
                        },
                        error: function (data) {
                            if (AJAX_MODE === 'dev') {
                                data = mockups.fanId;
                                if (isDataCorrect(data) && data?.payload?.ResultCode !== '20115') {
                                    successFn(ajaxData.fanId);

                                } else {
                                    errorFn(data);
                                }
                            } else {
                                errorFn(data);
                            }
                        },
                        timeout: 30000
                    });

                    function successFn(fanId){
                        $domElements.modalSendFanId.removeClass('active-effect');
                        setTimeout(() => {
                            $domElements.modalSendFanId.removeClass('active');
                        }, 50);
                        $domElements.body.css('overflow', 'auto');
                        $domElements.modalSendFanId.removeClass('loading');
                        $('#fan_id_input').val('');
                        $('#fan_id_input').parents('.field').removeClass('success').addClass('empty');
                        //записываем в куку время бронирования
                        const dateWithTimeZone = new Date();
                        dateWithTimeZone.setHours(dateWithTimeZone.getHours() - new Date().getTimezoneOffset() / 60);
                        dateWithTimeZone.setMinutes(dateWithTimeZone.getMinutes() + 30);
                        setCookie('deadline', dateWithTimeZone);
                        initDeadlineTimer('extend');
                    }

                    function errorFn(data){

                        //ошибка бронирования - уже зарезервированно
                        if(data?.payload?.ResultCode === '20115'){
                            $domElements.modalSendFanId.find('.ticket_system__fan-id-modal-error').html(`
                        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 80px;height: 80px;">
                            <circle cx="40.5" cy="40.5" r="40.5" fill="#FF5C5C"/>
                            <path d="M57.3322 24L32.1239 49.2083L24 57.3324" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M24 24L49.2083 49.2084L57.3324 57.3323" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="ticket-system__fanid-error-title">${translator('Ошибка',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text">${translator('К сожалению, данное место уже забронировано, выберите другое',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__button--darkCyan" data-ticket-system__fanid-choose-different>${translator('Выбрать место',WIDGET_DATA.lang)}</div> 
                    `);

                        }else{
                            $domElements.modalSendFanId.find('.ticket_system__fan-id-modal-error').html(`
                        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 80px;height: 80px;">
                            <circle cx="40.5" cy="40.5" r="40.5" fill="#FF5C5C"/>
                            <path d="M57.3322 24L32.1239 49.2083L24 57.3324" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M24 24L49.2083 49.2084L57.3324 57.3323" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="ticket-system__fanid-error-title">${translator('Ошибка',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text">${translator('Информация не найдена или введена не корректно.',WIDGET_DATA.lang)}</div>
                        <div class="ticket-system__fanid-error-text left-align-text">${translator('Введите:',WIDGET_DATA.lang)}</div>
                         <div class="ticket-system__fanid-error-text ticket-system-list-style">
                            <div class="ticket-system__fanid-error-text ticket-system__no-margin-top">${translator('№ карты болельщика в формате 123456789 (9 символов). Карту болельщика можно оформить в личном кабинете на сайте', WIDGET_DATA.lang)} <a target="_blank" href="https://www.gosuslugi.ru/fancard">${translator('Госуслуги', WIDGET_DATA.lang)}</a>.</div>
                        </div>
                        <div class="ticket-system__fanid-error-text">${translator('Если вы указали все верно, но появляется ошибка - напишите на ', WIDGET_DATA.lang)}<a href="mailto:tickets@ks-samara.com">tickets@ks-samara.com</a>.</div>
                        <div class="ticket-system__button--darkCyan" data-ticket-system__fanid-try-again>${translator('Попробовать ещё раз',WIDGET_DATA.lang)}</div>
                    `);
                        }

                        $domElements.modalSendFanId.removeClass('loading');
                        $domElements.modalSendFanId.addClass('error');
                    }
                }
            }
        }
    }

    //отправление кода подтверждения на телефон/почту
    function sendPassword() {
        showPreloader();

        let clearLoginFieldValue = '';
        let textBlockTemplate = '';
        let pageTitleTemplate = '';

        if (WIDGET_DATA.currentPhoneOrEmailMask === 'phone') {
            clearLoginFieldValue = $domElements.submitOrderEmailOrPhoneInput.val().replace(/[\-\+\(\)\ ]/g, '').slice(1);
            pageTitleTemplate = 'Введите код из SMS';
            textBlockTemplate = `Код отправлен на номер <span style="font-weight: bold;white-space: pre;">${$domElements.submitOrderEmailOrPhoneInput.val()}</span>`;
            WIDGET_DATA.checkPasswordInputValidate = '4';
            $('#check_password').attr('maxLength', 4);

        } else if (WIDGET_DATA.currentPhoneOrEmailMask === 'email') {
            clearLoginFieldValue = $domElements.submitOrderEmailOrPhoneInput.val();
            pageTitleTemplate = 'Введите код из E-mail';
            textBlockTemplate = `Почта получателя: <span style="font-weight: bold;white-space: pre;">${$domElements.submitOrderEmailOrPhoneInput.val()}</span>`;
            WIDGET_DATA.checkPasswordInputValidate = '6';
            $('#check_password').attr('maxLength', 6);
        }

        WIDGET_DATA.checkPasswordLoginValue = clearLoginFieldValue;

        const data = {
            "login": clearLoginFieldValue
        }

        $.ajax({
            url: `${AJAX_AUTH_URL}/sendPassword`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                success(data);
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.sendPassword;
                    success(data);
                } else {
                    error(data);
                }
            },
            timeout: 30000
        });

        function success() {
            $('.ticket-system__submit-order-title').hide();
            $domElements.submitOrderInputsWrapper.hide();

            hidePreloader();
            let timer = 60;

            //ставим флаг, что мы сейчас на подтверждении телефона/почты
            WIDGET_DATA.isSubmitLoginSection = 1;

            //меняем загловок, скрываем инпуты
            $domElements.checkPasswordBlock.removeClass('ticket-system__hide');
            $domElements.contentTitle.text(pageTitleTemplate);
            $('[data-ticket-system-submit-order-inputs-wrapper]').addClass('ticket-system__hide');
            $('[data-ticket-system-submit-order-check-password-text]').html(textBlockTemplate);
            $('[data-ticket-system-submit-order-submit-form]').addClass('ticket-system__hide');
            $('.ticket-system__submit-order-description').hide();

            $('[data-tickets-system-timer]').text(`Отправить повторно через ${timer} сек.`);
            //включаем счетчик
            WIDGET_DATA.timerInterval = setInterval(() => {
                    timer--;

                    if (timer === 0) {
                        clearInterval(WIDGET_DATA.timerInterval);
                        $('[data-tickets-system-timer]').addClass('finished');
                        $('[data-tickets-system-timer]').text(`Отправить повторно`);

                    } else {
                        $('[data-tickets-system-timer]').text(`Отправить повторно через ${timer} сек.`);
                    }

                }, 1000
            );
        }

        function error(data) {
            getUserProfile();
        }
    }

    //отправка полученного кода для подтверждения телефона/почты
    function checkPassword() {
        showPreloader();

        if (validateCheckPasswordInput()) {

            const data = {
                code: $('#check_password').val(),
                login: WIDGET_DATA.checkPasswordLoginValue
            }

            $.ajax({
                url: `${AJAX_AUTH_URL}/checkPassword`,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    if (AJAX_MODE === 'dev') {
                        data = mockups.checkPassword;
                        success(data);
                    } else {
                        error(data);
                    }
                },
                timeout: 30000
            });

            function success(data) {
                if (data?.status === 'success') {
                    //делаем запрос за профилем пользователя
                    getUserProfile();

                    //время жизни кода истекло
                } else if (data?.status === 'expired') {
                    $('[data-ticket-system__submit-order-check-password-error-block]').text('Введен неверный код');
                    $('[data-ticket-system__submit-order-check-password-error-block]').show();
                    hidePreloader();

                    //некорректный код
                } else if (data?.status === 'incorrect') {
                    $('[data-ticket-system__submit-order-check-password-error-block]').text('Введен неверный код');
                    $('[data-ticket-system__submit-order-check-password-error-block]').show();
                    hidePreloader();
                }
            }

            function error() {
            }
        }
    }

    //валидация на вводе пароля подтверждения
    function validateCheckPasswordInput() {
        if (WIDGET_DATA.checkPasswordInputValidate === '4') {
            if ($('#check_password').val().length !== 4) {
                $('#check_password').siblings('.error-message').text('Минимум 4 цифры');
                $('#check_password').parents('.field').removeClass('empty').removeClass('success').addClass('error');
                return false;
            }

        } else if (WIDGET_DATA.checkPasswordInputValidate === '6') {
            if ($('#check_password').val().length !== 6) {
                $('#check_password').siblings('.error-message').text('Минимум 6 цифр');
                $('#check_password').parents('.field').removeClass('empty').removeClass('success').addClass('error');
                return false;
            }
        }
        return true;
    }

    //запрос за пользователем
    //оффнут 31.05 - новый дизайн Оформления заказа

    function getUserProfile() {
        $.ajax({
            url: `${AJAX_USER_PROFILE_URL}/getUserProfile`,
            type: 'GET',
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                success(data);
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.getUserProfile;
                    success(data);
                } else {
                    error(data);
                }
            },
            timeout: 30000
        });

        function success(data) {
            if (data) {
                setUserFields(data);

            } else {
                error();
            }
        }

        function error() {
            createOrder();
        }

        function setUserFields(data) {
            //создаём объект, где будем менять данные и переносим туда поля с данных о пользователе с сервера
            let newUserData = {};
            Object.assign(newUserData, data);

            //если какое-то из полей пустое - вводим заполненные пользователем данные
            if (newUserData.name === null || newUserData.name === '') {
                newUserData.name = $('#first_name_input').val();

            }

            if (newUserData.lastname === null || newUserData.lastname === '') {
                newUserData.lastname = $('#last_name_input').val();

            }

            //заполняем поле email, если оно пустое в лк и пользователь ввёл email в виджете на подтверждении
            if (newUserData.email === null && WIDGET_DATA.currentPhoneOrEmailMask === 'email') {
                newUserData.email = WIDGET_DATA.checkPasswordLoginValue;
            }

            //заполняем телефон, если пустой в лк и пользователь ввёл теелфон в виджете на подтверждении
            if (newUserData.phone === null && WIDGET_DATA.currentPhoneOrEmailMask === 'phone') {
                newUserData.email = WIDGET_DATA.checkPasswordLoginValue;
            }
            $.ajax({
                url: `${AJAX_USER_PROFILE_URL}/saveUserProfile`,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(newUserData),
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    success(data);
                },
                error: function (data) {
                    success(data);
                },
                timeout: 30000
            });

            function success() {
                createOrder();
            }
        }
    }

    function setCookie(name, value, minutes) {
        const date = new Date();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function saveUtmParameters() {
        // Проверяем, существуют ли уже сохраненные UTM параметры в cookie
        if (getCookie('utmParams')) {
            return; // Если параметры уже существуют, не перезаписываем их
        }

        const params = new URLSearchParams(window.location.search);
        const utmParams = [];

        params.forEach((value, key) => {
            if (key !== 'matchId' && !key.includes('orderId')) {
                utmParams.push(`${key}=${value}`);
            }
        });

        const utmString = utmParams.join('&');
        setCookie('utmParams', utmString, 30); // Сохраняем параметры в cookie на 30 минут
    }

    saveUtmParameters();

    // Получаем utm параметры из cookie
    const utmString = getCookie('utmParams') || '';


    //создание заказа
    function createOrder() {
        showPreloader();
        //получаем ссылку на матч на сайте (для обратного редиректа со страницы банка)
        const requestUrl = window.location.origin + window.location.pathname;

        //списаны ли бонусы
        const isBonusesWriteOff = $domElements.orderInfoToggleBonuses.find('.switcher-gray').hasClass('active');

        //есть ли промокод
        const promocode = {
            code: null
        }

        if(WIDGET_DATA.promocodeData.code &&
            WIDGET_DATA.promocodeData.discount_value &&
            WIDGET_DATA.promocodeData.discount_value &&
            WIDGET_DATA.promocodeData.min_value !== null){
            promocode.code = WIDGET_DATA.promocodeData.code.toUpperCase();
        }

        //выбранные билеты тут не нужны - бек формирует заказ по предыдущему бронированию
        const data = {
            matchId: WIDGET_DATA.matchId,
            requestUrl,
            amount: WIDGET_DATA.orderFullPrice,
            user: {
                first_name: $domElements.submitOrderFirstNameInput.val(),
                last_name: $domElements.submitOrderLastNameInput.val()
            },
            subscription: WIDGET_DATA.isAbonement,
            bonus: isBonusesWriteOff ? WIDGET_DATA.bonusesWriteOff : 0,
            promocode: promocode,
            tickets:[],
            lang: WIDGET_DATA.lang,
            utm: utmString
        }

        WIDGET_DATA.chosenTickets.forEach(ticket => {
            let fanIdVal = ticket?.fanId ? `${ticket?.fanId}` : 'ошибка получения';

            //если идут закостыленные матчи без faid - пустая строка
            if(!WIDGET_DATA.fanIdRequired){
                fanIdVal = '';
            }

            data.tickets.push(
                {
                    place: `${ticket.id}`,
                    first_name: $domElements.submitOrderFirstNameInput.val(),
                    last_name: $domElements.submitOrderLastNameInput.val(),
                    fanId: ticket?.fanId ? `${ticket?.fanId}` : 'ошибка получения'
                }
            );
        });

        $domElements.submitOrderForm.find('input.input-text').each((_, input) => {
            if ($(input).attr('name') === 'phone_or_email') {
                //если маска - телефон, то убираем первую 7
                if (WIDGET_DATA.currentPhoneOrEmailMask === 'phone') {
                    //значение номера телефона без '+' и кода страны
                    data.user[$(input).attr('name')] = $(input).val().replace(/[\-\+\(\)\ ]/g, '').slice(1);
                } else {
                    data.user[$(input).attr('name')] = $(input).val();
                }
            }
        });

        delete data.user.check_password;

        $.ajax({
            url: `${AJAX_URL}/ajax/createOrder/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data && data?.resultCode === '200' && data?.payload?.status === 'success' && data?.payload?.link) {
                    successFn(data.payload);

                //если бронь уже удалилась, но пользователь остался на странице выбора места и уходит на оплату
                } else if(data && data?.payload?.statusCode === '33' && data?.payload?.status === 'error'){
                    errorHandler(data, 'createOrder-booking-overdue');

                }else if(data?.payload?.status === 'unauthorized') {
                    errorHandler(data, 'unauthorized');

                } else {
                    errorHandler(data, 'createOrder');
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.createOrder.payload;
                    if (data && data?.resultCode === '200' && data?.payload?.status === 'success' && data?.payload?.link) {
                        successFn(data.payload);

                    } else {
                        errorHandler(data, 'createOrder');
                    }

                } else {
                    errorHandler(data, 'createOrder');
                }
            },
            timeout: 30000
        });

        function successFn(data) {
            //очищаем все куки
            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
            setCookie('deadline', false);

            //редирект на страницу банка
            window.location.href = data?.link;
        }
    }

    function sendPaymentStatus(orderId) {
        showPreloader();

        const data = {
            paymentRegNum: orderId,
            /* userId: WIDGET_DATA.userId*/
        }

        $.ajax({
            url: `${AJAX_URL}/ajax/sendPaymentStatus/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                isDataValid(data);
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.sendPaymentStatus;
                    isDataValid(data);

                } else {
                    errorFn();
                }
            },
            timeout: 30000
        });

        function isDataValid(data) {
            if (
                data
                && data?.payload?.status === 'success'
                && data?.resultCode === '200'
                && data?.payload?.hash !== 0
                && data?.payload?.hash !== ''
            ) {
                WIDGET_DATA.orderId = data.payload.orderId;
                WIDGET_DATA.hashForTicketsPage = data.payload.hash;
                WIDGET_DATA.emailFromSendPaymentStatus = data?.payload?.email;

                successFn();

            } else if (data?.payload?.status === 'wait' || data?.resultCode !== '200') {
                errorFn(data);

            } else if (data?.payload?.status === 'error') {
                errorHandler(data, 'sendPaymentStatus');
            }
        }

        function successFn() {
            //записываем, что мы получили билеты, чтобы при переходе на страницу с билетами не запускать запрос заново
            WIDGET_DATA.isPaymentStatusSuccess = 1;
            initTicketsPageHandlers();

            //если уже на странице билетов -> рендерим её без перехода
            if (window.location.hash === '#tickets_page') {
                navigateTo('tickets_page');

            } else {
                route('tickets_page');
            }

            hidePreloader();
        }

        // повторяем запрос через 5 секунд в случае, если запрос не выполнился/ ошибка на сервере или сбере и статус оплаты не известен
        // 5 запросов максимум
        function errorFn(data) {
            WIDGET_DATA.sendPaymentStatusCount++;

            if (WIDGET_DATA.sendPaymentStatusCount === 6) {
                errorHandler(data, 'sendPaymentStatus');
                return;
            }

            setTimeout(() => {
                sendPaymentStatus(orderId);
            }, 5000);
        }
    }

    function errorHandler(data, errorKey = '') {

        if(data?.payload?.statusCode === '20111'){
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Уважаемый болельщик!',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('В настоящее время покупка доступна только для владельцев абонементов на сезон 2022/2023. Покупка абонемента для Вас будет доступна с 19.06.2023.',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('Выбрать другой матч',WIDGET_DATA.lang)}</div>
            `);
            navigateTo('error_page');
            return;
        }

        //'bonuses' ошибки для бонусной и промокодной системы
        if(errorKey === 'bonuses'){
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator(data?.errorText ,WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('Пожалуйста, обновите страницу',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Обновить страницу', WIDGET_DATA.lang)}</div>
             `);
        }

        //20110, запрос за секторами, description = 'Продажа запрещена' -> ссылка на прошедший матч
        if(data?.payload?.statusCode === '20110' && errorKey ==='get-sectors' && data?.payload?.description && data?.payload?.description === 'Продажа запрещена!'){
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Данное мероприятие уже состоялось.',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('Выберите другой матч.',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('Выбрать другой матч', WIDGET_DATA.lang)}</div>
             `);
        }

        //если бронь после 30м удалилась и пользователь уходит на оплату
        if(data?.payload?.statusCode === '33' && errorKey ==='createOrder-booking-overdue'){
            setCookie('deadline', false);
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Время ожидания выбора мест истекло',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('Пожалуйста, обновите страницу',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Обновить страницу', WIDGET_DATA.lang)}</div>
             `);
        }

        //в случае если пользователь после покупки 4-х билетов пытается купить ещё (ограничение)
        if (data?.payload?.statusCode && data?.payload?.statusCode === '20124' && !data?.payload?.typeSubscription) {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Превышено ограничение',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('На данное мероприятие нет возможности приобрести больше 20 билетов на 1 человека',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('Выбрать другой матч',WIDGET_DATA.lang)}</div>
            `);
        }

        //в случае если пользователь после покупки 4-х абонементов пытается купить ещё (ограничение)
        if (data?.payload?.statusCode && data?.payload?.statusCode === '20124' && data?.payload?.typeSubscription) {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Уважаемый болельщик!',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-description">${translator('В период с 1.06 по 15.06 у вас есть возможность приоритетного права покупки абонемента на сезон 2022/2023 гг по специальной цене. Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись с указанием информации о владельце сезонного абонемента.',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('Выбрать другой матч',WIDGET_DATA.lang)}</div>
            `);
        }

        //в случае если пользователь пытается купить абонемент в тек сезоне, но без покупки в предыдущем
        if (!data?.payload?.description && data?.payload?.statusCode && (data?.payload?.statusCode === '20110' || data?.payload?.statusCode === '20121')) {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Покупка абонемента для вас недоступна, так как вами уже был приобретён абонемент',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('На главную',WIDGET_DATA.lang)}</div>
            `);
        }

        //ошибка инициализации виджета
        if (errorKey === 'widget' && data?.payload?.statusCode !== '20110' && data?.payload?.statusCode !== '20124') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Ошибка инициализации',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
            `);
        }

        //ошибка получения мест
        if (errorKey === 'places') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Сектор недоступен, выберите другой',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
            `)

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        //ошибка бронирования
        if (errorKey === 'booking' && data?.payload?.statusCode !== '20115') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Ошибка обработки данных, попробуйте еще раз',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
            `)

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        //ошибка бронирования (уже зарезервированно)
        if (errorKey === 'booking' && data?.payload?.statusCode === '20115') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Извините, похоже какое то место в заказе не доступно для покупки',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Выбрать другое место',WIDGET_DATA.lang)}</div>
            `)

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        //ошибка создания заказа
        if (errorKey === 'createOrder') {
            setCookie('deadline', false);
            if(data?.payload?.statusCode && data?.payload?.statusCode === '20124'){
                $domElements.errorPage.html(`
                    <div class="ticket-system__error-page-text">${translator('Превышено ограничение',WIDGET_DATA.lang)}</div>
                    <div class="ticket-system__error-page-description">${translator('На данное мероприятие нет возможности приобрести больше 20 билетов на 1 человека',WIDGET_DATA.lang)}</div>
                    <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>${translator('Выбрать другой матч',WIDGET_DATA.lang)}</div>
                `)
            }else{
                $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Не удалось оформить билет',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
            `)
            }

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        if(errorKey === 'unauthorized'){
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Вы не авторизованы',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system-error-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
            `);
        }

        //ошибка получения статуса оплаты
        if (errorKey === 'sendPaymentStatus') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">${translator('Ошибка обработки платежа',WIDGET_DATA.lang)}</div>
                <div class="ticket-system__error-page-buttons-wrapper">
                    <div class="ticket-system__button--send-to-email" data-ticket-system__return-to-choose-match>${translator('На главную',WIDGET_DATA.lang)}</div>
                    <div class="ticket-system__button--darkCyan" data-ticket-system-error-refresh-button>${translator('Попробуйте ещё раз',WIDGET_DATA.lang)}</div>
                </div>
            `);

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        //попытка покупки абонемента в случае, если человек не покупал абонемент до этого
        if (errorKey === 'abonement') {
            $domElements.errorPage.html(`
                <div class="ticket-system__error-page-text">Данный абонемент для вас недоступен</div>
                <div class="ticket-system__button--darkCyan" data-ticket-system__return-to-choose-match>Вернуться назад</div>
            `)

            setCookie('chosen_sector', null);
            setCookie('chosen_tickets', null);
            setCookie('chosen_tickets_current_page', null);
        }

        navigateTo('error_page');
    }

    function initTicketsPageHandlers() {

        //клик по закрытию модалки
        $domElements.body.on('click', '[data-ticket-system-tickets-page-close-modal]', () => {
            hideFlexBlock($domElements.ticketsPageModal);
            $domElements.ticketsPageModalFormError.hide();
            $domElements.ticketsPageModalFormSuccess.hide();
            $domElements.ticketsPageModalTitle.show();
            $domElements.ticketsPageModalForm.css('display', 'flex');
            //чистим инпут
            clearInput();
        });

        //клик по "Отправить на почту"
        $domElements.body.on('click', '[data-ticket-system-tickets-page-open-modal]', () => {
            showFlexBlock($domElements.ticketsPageModal);
        });

        //клик по "Сохранить билет"
        $domElements.body.on('click', '[data-ticket-system-tickets-page-save-tickets]', () => {
            getTicketPDF();
        });

        //при уходе с инпута тоже валидируем его
        $domElements.body.on('blur', '#email_for_sending_ticket', () => {
            validateField($('#email_for_sending_ticket'));
        });

        //клик по "Отправить" в модалке при отправлении билетов на email
        $domElements.body.on('click', '[data-ticket-system-tickets-page-send-tickets]', () => {
            if (validateField($domElements.ticketsPageModalInput)) {
                sendTicketOnEmail();
            }

        });

        //клик по "На главную" при успешной отправке билетов на почту
        $domElements.body.on('click', '[data-ticket-system__tickets-page-return-to-main]', () => {
            //получаем изначальную ссылку для редиректа
            window.location.href = window.location.origin + window.location.pathname;
        });

        //клик по "Повторить" при неудачной отправке билетов на почту
        $domElements.body.on('click', '[data-ticket-system__tickets-page-try-again]', () => {
            //отправляем ещё один запрос
            $domElements.ticketsPageModalTitle.show();
            $domElements.ticketsPageModalFormError.hide();
            sendTicketOnEmail();
        });


        function showFlexBlock($block) {
            $block.css('display', 'flex');
        }

        function hideFlexBlock($block) {
            $block.css('display', 'none');
        }

        function clearInput() {
            const $field = $domElements.ticketsPageModalInput.parents('.field');
            $domElements.ticketsPageModalInput.val('');
            $field.removeClass('error');
            $field.removeClass('success');
            $field.addClass('empty');
            $field.find('.error-message').text('');
        }
    }

    //отправка билетов на почту
    function sendTicketOnEmail() {
        showModalPreloader();

        const data = {
            orderId: WIDGET_DATA.orderId,
            mail: $domElements.ticketsPageModalInput.val(),
            hash: WIDGET_DATA.hashForTicketsPage
        }

        $.ajax({
            url: `${AJAX_URL}/ajax/sendTicketPdf/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data)) {
                    successFn();

                } else {
                    errorFn();
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.sendTicketOnEmail;

                    if (isDataCorrect(data)) {
                        successFn();

                    } else {
                        errorFn();
                    }

                } else {
                    errorFn();
                }
            },
            timeout: 30000
        });

        function successFn() {
            hideModalPreloader();
            $domElements.ticketsPageModalTitle.hide();
            $domElements.ticketsPageModalFormError.hide();
            $domElements.ticketsPageModalFormSuccess.css('display', 'flex');
        }

        function errorFn() {
            hideModalPreloader();
            $domElements.ticketsPageModalTitle.hide();
            $domElements.ticketsPageModalFormError.css('display', 'flex');
        }

        function showModalPreloader() {
            $domElements.ticketsPageModalForm.css('display', 'none');
            $domElements.ticketsPageModalPreloader.show();
        }

        function hideModalPreloader() {
            $domElements.ticketsPageModalPreloader.hide();
        }
    }

    //сохранение pdf билета
    function getTicketPDF() {
        if(WIDGET_DATA.lang === 'ru'){
            window.open(`${AJAX_URL}/getTicket/?orderId=${WIDGET_DATA.orderId}&lang=ru&hash=${WIDGET_DATA.hashForTicketsPage}`, '_blank');

        }else if(WIDGET_DATA.lang === 'en'){
            window.open(`${AJAX_URL}/getTicket/?orderId=${WIDGET_DATA.orderId}&lang=en&hash=${WIDGET_DATA.hashForTicketsPage}`, '_blank');
        }
    }

    //проверка данных в куке
    function checkCookie() {
        WIDGET_DATA.localState = {
            chosenSector: getCookie('chosen_sector'),
            chosenTickets: getCookie('chosen_tickets')
        }
    }

    function checkMobileSlider() {
        //если текущее значение фильтра отличается от дефолтного -> меняем текст "Фильтры" на ценовой диапазон
        //иначе ставим "Фильтры"
        if (WIDGET_DATA.defaultMaxPrice !== WIDGET_DATA.sliderTo || WIDGET_DATA.defaultMinPrice !== WIDGET_DATA.sliderFrom) {
            const currentMinPricePretty = number_format(WIDGET_DATA.sliderFrom, '', '', ' ');
            const currentMaxPricePretty = number_format(WIDGET_DATA.sliderTo, '', '', ' ');

            $domElements.filterMobileText.text(`${currentMinPricePretty} ₽ - ${currentMaxPricePretty} ₽`);

        } else {
            $domElements.filterMobileText.text('Фильтры');
        }
    }

    //сброс зума
    function resetZoom() {
        WIDGET_DATA.zoomValue = 100;
        $domElements.placesRender.removeClass('ticket-system__choose-places-zoom-x1_5 ticket-system__choose-places-zoom-x2');
        $domElements.chooseSectorDrawing.css('width', '100%');
        zoomPlaces(1);

        $domElements.zoomInIcon.css('background-color', '#0063FF');
        $domElements.zoomOutIcon.css('background-color', '#C5D2E8');
    }

    //зум для мест
    function zoomPlaces(value) {
        const defaultPlacesRenderWidth = $domElements.placesWrapper.data('ticket__places-render-default-width');
        const defaultPlacesRenderHeight = $domElements.placesWrapper.data('ticket__places-render-default-height');

        //зум мест
        WIDGET_DATA.placesDOMElements.forEach(placeDomElement => {
            const $place = $(placeDomElement);
            const defaultPlaceX = $place.data('ticket__default-x');
            const defaultPlaceY = $place.data('ticket__default-y');

            $place.css('bottom', `${defaultPlaceY * value}px`);
            $place.css('left', `${defaultPlaceX * value}px`);
        });

        //зум всех номеров ряда
        $domElements.placesRowsWrapper.find('.ticket-system__choose-places-row-number').each((_, rowBlock) => {
            const $rowBlock = $(rowBlock);
            const defaultRowBlockY = $rowBlock.data('ticket__row-default-y');

            $rowBlock.css('bottom', `${defaultRowBlockY * value}px`);
        });

        if (value === 1) {
            $domElements.placesRowsWrapper.css('width', '26px');

        } else if (value === 1.2) {
            $domElements.placesRowsWrapper.css('width', '30px');

        } else if (value === 1.5) {
            $domElements.placesRowsWrapper.css('width', '38px');
        }

        //зум обертки
        $domElements.placesWrapper.css('width', `${defaultPlacesRenderWidth * value}px`);
        $domElements.placesWrapper.css('height', `${defaultPlacesRenderHeight * value}px`);
    }

    //получение бонусов
    function getPoints(checkAfter = false){

        let ticketFullPrice = 0;

        WIDGET_DATA.chosenTickets.forEach(ticket => {
            ticketFullPrice += +ticket.price;
        });

        const data = {
            orderPrice: ticketFullPrice,
            application: "ticket_system",
            promocode: WIDGET_DATA.promocodeData.code || null,
            products: [
                {"id": +WIDGET_DATA.matchId,
                "price": ticketFullPrice/WIDGET_DATA.chosenTickets.length,
                "count":WIDGET_DATA.chosenTickets.length}
            ]
        }
        console.log(WIDGET_DATA.promocodeData)
/*        if(checkAfter){
            data.promocode = WIDGET_DATA.promocodeData.code || '';
        }*/

       /* if(!WIDGET_DATA.isPromocodesAvailable) {
            WIDGET_DATA.fullPrice = ticketFullPrice;
            WIDGET_DATA.priceAccrue = ticketFullPrice;
            WIDGET_DATA.priceWriteOff = ticketFullPrice;
            $('[data-use-user-points-block]').hide();
            $domElements.orderInfoBonusesValue.hide();
            calculateFullPrice(WIDGET_DATA);
            hidePreloader();
            return;
        }*/

        $.ajax({
            url: `${AJAX_AUTH_URL}/api/bonus/getBonusData`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if(data.status === 'OK'){
                    success(data);
                } else {
                    errorHandler(data, 'bonuses');
                }

            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.getBonuses;
                    console.log(mockups.getBonuses)
                    success(data);
                } else {
                    errorHandler(data, 'bonuses');
                }
            },
            timeout: 30000
        });

        function success(data){
            if(data){
                if (data.payload.count && data.payload.count !== '0' && data.payload.count !== 0
                    && data.payload.maxWriteOff && data.payload.maxWriteOff !== '0' && data.payload.maxWriteOff !== 0 ){
                    if($('[data-use-user-points-block]').is(':hidden')){
                        $('[data-use-user-points-block]').show();
                    }
                    $domElements.bonusesWriteOff.text(data.payload.maxWriteOff);
                    $domElements.bonusesAll.text(data.payload.count);
                    WIDGET_DATA.bonusesWriteOff = +data.payload.maxWriteOff;
                    WIDGET_DATA.priceAccrue = +data.payload.amountPay.accrue;
                    WIDGET_DATA.priceWriteOff = +data.payload.amountPay.writeOff;
                    WIDGET_DATA.fullPrice = +data.payload.amountPay.fullPrice;

                } else {
                    WIDGET_DATA.priceAccrue = +data.payload.amountPay.accrue;
                    WIDGET_DATA.priceWriteOff = +data.payload.amountPay.writeOff;
                    WIDGET_DATA.fullPrice = +data.payload.amountPay.fullPrice;
                    $('[data-use-user-points-block]').hide();

                    if($('[data-use-user-points-block] .switcher-gray').hasClass('active')){
                        $('[data-use-user-points-block] .switcher-gray').removeClass('active')
                        $domElements.orderInfoBonusesValue.removeClass('ticket-system__hide')
                    }
                }

                //зеленая плашка
                if(data.payload.maxAccrue && data.payload.maxAccrue !== '0' && data.payload.maxAccrue !== 0){
                    $domElements.orderInfoBonusesValue.text(`+ ${data.payload.maxAccrue} ${getRightTerm(data.payload.maxAccrue, 'бонус', 'бонуса', 'бонусов')}`);

                }else{
                    $domElements.orderInfoBonusesValue.hide();
                }

                //сообщение (warning) в промо
                if(data.payload?.promoCode?.message && WIDGET_DATA.promocodeData.code){
                    $('[data-promocode-message]').text(data.payload.promoCode.message);
                    $('[data-promocode-message]').removeClass('ticket-system__hide');
                }else{
                    $('[data-promocode-message]').addClass('ticket-system__hide');
                }
            }
            calculateFullPrice(WIDGET_DATA);
            hidePreloader();
        }

        function error(){
            $('[data-use-user-points-block]').hide();
        }
    }

    //таймер, если есть забронированные места с getWidgetData
    function initDeadlineTimer(flag){
        //инициализация при получении забронированных мест на getWidgetData
        if(WIDGET_DATA.userInfo.seatInReserve.length && !flag){

            //получаем остаток времени и запускаем таймер
            const cookieDeadline = getCookie('deadline');
            const trueCookieHours = new Date(cookieDeadline).getHours() + new Date().getTimezoneOffset() / 60;
            let timeValueInSeconds = (new Date(cookieDeadline).setHours(trueCookieHours) - new Date()) / 1000;

            if(timeValueInSeconds > 0){
                startTimer(timeValueInSeconds);

            //если куки нет (заход с другого устройства) - не показываем таймер и забронированные места
            }else if(!cookieDeadline){
                hidePreloader();

            }else{
                $domElements.deadlineTimer.removeClass('ticket-system__hide');
                $domElements.deadlineTimer.css('display', 'flex');
                $domElements.deadlineTimerValue.text(`00:00`);
                showModalBookingDeadline();
                hidePreloader();
            }


        }else if(flag){
            startTimer(1800);

        }else{
            $domElements.deadlineTimer.add('ticket-system__hide');
        }

        function startTimer(timeValueInSeconds){
            let isTimerInited = 0;

            //если инстанс уже есть и мы вызываем ещё раз запуск таймера - останавливаем его
            if(WIDGET_DATA.deadlineTimerInstance){
                clearInterval(WIDGET_DATA.deadlineTimerInstance);
                WIDGET_DATA.deadlineTimerInstance = 0;
            }

            WIDGET_DATA.deadlineTimerInstance = setInterval(function (){
                if (timeValueInSeconds <= 0){
                    $domElements.deadlineTimerValue.text(`00:00`);
                    clearInterval(WIDGET_DATA.deadlineTimerInstance);
                    WIDGET_DATA.deadlineTimerInstance = 0;
                    setCookie('deadline', false);
                    showModalBookingDeadline();

                }else{
                    const minutes = Math.floor(timeValueInSeconds / 60 % 60);
                    const seconds = Math.floor(timeValueInSeconds % 60);
                    const additionalZeroMinutes = minutes.toString().length > 1 ? '' : '0';
                    const additionalZeroSeconds = seconds.toString().length > 1 ? '' : '0';

                    $domElements.deadlineTimerValue.text(`${additionalZeroMinutes}${minutes}:${additionalZeroSeconds}${seconds}`);

                    //после инициализации таймера - скрываем прелоадер
                    if(!isTimerInited){

                        isTimerInited = 1;
                        $domElements.deadlineTimer.removeClass('ticket-system__hide');
                        $domElements.deadlineTimer.css('display', 'flex');
                        hidePreloader();
                    }
                }

                --timeValueInSeconds;
            }, 1000);
        }

        function showModalBookingDeadline(){
            $domElements.body.css('overflow', 'hidden');
            $('#ticket_system__deadline__modal').addClass('active');
            setTimeout(() => {
                $('#ticket_system__deadline__modal').addClass('active-effect');
            }, 50);
        }
    }

    //запрос за валидацией промокода
    function validatePromocode(promocodeVal, checkBonusesAvailable = false){
        showPreloader();

        //списаны ли бонусы
        const isBonusesWriteOff = $domElements.orderInfoToggleBonuses.find('.switcher-gray').hasClass('active');

        const data = {
            promocode: promocodeVal,
            order: WIDGET_DATA.chosenTickets,
            orderFullPrice:WIDGET_DATA.currentFullPrice,
            matchId: +WIDGET_DATA.matchId,
            bonus: isBonusesWriteOff ? WIDGET_DATA.bonusesWriteOff : 0
        }

        $.ajax({
            url: `${AJAX_URL}/ajax/validatePromocode/`,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (isDataCorrect(data) && data?.payload?.promocode && data?.payload?.promocode?.discount_value && data?.payload?.promocode?.discount_type) {
                    promocodeValidationSuccess(data.payload.promocode);

                } else {
                    promocodeValidationError(data.payload);
                }
            },
            error: function (data) {
                if (AJAX_MODE === 'dev') {
                    data = mockups.validatePromocode.success;
                    if (isDataCorrect(data) && data?.payload?.promocode && data?.payload?.promocode?.discount_value && data?.payload?.promocode?.discount_type) {
                        promocodeValidationSuccess(data.payload.promocode);

                    } else {
                        promocodeValidationError(data.payload);
                    }
                } else {
                    promocodeValidationError(data.payload);
                }
            },
            timeout: 30000
        });

        function promocodeValidationSuccess(promocodeData){
            WIDGET_DATA.isPromocodesAvailable = true;
            WIDGET_DATA.promocodeData.discount_type = promocodeData.discount_type;
            WIDGET_DATA.promocodeData.discount_value = promocodeData.discount_value;
            WIDGET_DATA.promocodeData.min_value = promocodeData.min_value;
            WIDGET_DATA.promocodeData.code = promocodeVal;
            WIDGET_DATA.promocodeData.isPromocodeAccepted = true;
            console.log(WIDGET_DATA.promocodeData)
            $('.promocode-error').text('');
            $('.promocode-error').addClass('ticket-system__hide');

            $('.promocode-success').removeClass('ticket-system__hide');

            handlePromocode();

            if(checkBonusesAvailable){
                getPoints(true);

            }else{
                hidePreloader();
            }
        }

        function promocodeValidationError(data){
            $('#promocode_input').parent().addClass('error');
            $('.promocode-error').text(data.errorText);
            $('.promocode-error').removeClass('ticket-system__hide');
            $('.promocode-success').addClass('ticket-system__hide');
            WIDGET_DATA.promocodeData.isPromocodeAccepted = false;

            if(WIDGET_DATA.promocodeData.isPromocodeAccepted){
                WIDGET_DATA.promocodeData.discount_value = 0;
                WIDGET_DATA.promocodeData.discount_type = '';
                WIDGET_DATA.promocodeData.min_value = 0;
                renderTicketsPopup($domElements, WIDGET_DATA);
                renderTicketsInfo(WIDGET_DATA);
            }

            hidePreloader();
        }
    }

    //обработка промокода
    function handlePromocode(){
        if(WIDGET_DATA.isPromocodesAvailable){
            $('[data-promocode-in-price-block-value]').text(`- ${WIDGET_DATA.promocodeData.discount_value} ${WIDGET_DATA.promocodeData.discount_type}`);
            $('[data-promocode-in-price-block]').removeClass('ticket-system__hide');
            $('#promocode_input').parent().addClass('success').removeClass('error');
            $('#promocode_input').attr('disabled', true);

            $('.ticket-system__promocode-btn').addClass('ticket-system__hide');
            $('#promocode_input').siblings('svg').removeClass('ticket-system__hide');

        }else{
            WIDGET_DATA.isPromocodesAvailable = false;
            WIDGET_DATA.promocodeData.discount_value = 0;
            WIDGET_DATA.promocodeData.discount_type = '';
            WIDGET_DATA.promocodeData.min_value = 0;

            $('[data-promocode-in-price-block-value]').text(``);
            $('[data-promocode-in-price-block]').addClass('ticket-system__hide');
            $('#promocode_input').parent().removeClass('success').removeClass('error');

            $('#promocode_input').attr('disabled', false);
            $('.promocode-success').addClass('ticket-system__hide');

            $('#promocode_input').val('');
            $('#promocode_input').siblings('svg').addClass('ticket-system__hide');

            showPreloader();
            getPoints();
        }

        //ререндер попапа выбранных мест
        renderTicketsPopup($domElements, WIDGET_DATA);
        renderTicketsInfo(WIDGET_DATA);
    }
}
